var Ga = Object.defineProperty;
var er = (e, t, a) => t in e ? Ga(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var ye = (e, t, a) => (er(e, typeof t != "symbol" ? t + "" : t, a), a);
import { jsx as w, jsxs as X } from "react/jsx-runtime";
import H, { createContext as Ie, Component as tr, createElement as be, useRef as ar, useCallback as rr, forwardRef as Xt, useState as Pa, Suspense as nr, useEffect as or } from "react";
import * as ir from "@tanstack/react-query";
import { useSuspenseInfiniteQuery as sr, dehydrate as lr, hydrate as dr, QueryClientProvider as ur, QueryErrorResetBoundary as mr, QueryClient as cr } from "@tanstack/react-query";
import { I18nextProvider as fr, useTranslation as hr } from "react-i18next";
import "i18next";
const vr = Ie(null), Ue = {
  didCatch: !1,
  error: null
};
class gr extends tr {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Ue;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var a, r, n = arguments.length, o = new Array(n), s = 0; s < n; s++)
        o[s] = arguments[s];
      (a = (r = this.props).onReset) === null || a === void 0 || a.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(Ue);
    }
  }
  componentDidCatch(t, a) {
    var r, n;
    (r = (n = this.props).onError) === null || r === void 0 || r.call(n, t, a);
  }
  componentDidUpdate(t, a) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: n
    } = this.props;
    if (r && a.error !== null && pr(t.resetKeys, n)) {
      var o, s;
      (o = (s = this.props).onReset) === null || o === void 0 || o.call(s, {
        next: n,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(Ue);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: a,
      FallbackComponent: r,
      fallback: n
    } = this.props, {
      didCatch: o,
      error: s
    } = this.state;
    let i = t;
    if (o) {
      const l = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof a == "function")
        i = a(l);
      else if (r)
        i = be(r, l);
      else if (n !== void 0)
        i = n;
      else
        throw s;
    }
    return be(vr.Provider, {
      value: {
        didCatch: o,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, i);
  }
}
function pr() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((a, r) => !Object.is(a, t[r]));
}
var yr = /* @__PURE__ */ Ie({}), xa = "id";
function br(e) {
  return e === void 0 && (e = xa), (e ? e + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var Mr = /* @__PURE__ */ Ie(br);
function wr(e) {
  var t = e.children, a = e.prefix, r = a === void 0 ? xa : a, n = ar(0), o = rr(function(s) {
    return s === void 0 && (s = r), (s ? s + "-" : "") + ++n.current;
  }, [r]);
  return /* @__PURE__ */ be(Mr.Provider, {
    value: o
  }, t);
}
function Pr(e) {
  var t = e.children, a = e.unstable_system;
  return /* @__PURE__ */ be(yr.Provider, {
    value: a
  }, t);
}
var xr = {};
function Cr(e) {
  var t = e.unstable_prefix, a = e.unstable_system, r = a === void 0 ? xr : a, n = e.children;
  return /* @__PURE__ */ be(wr, {
    prefix: t
  }, /* @__PURE__ */ be(Pr, {
    unstable_system: r
  }, n));
}
const _r = ({ children: e, i18nInstance: t }) => /* @__PURE__ */ w(fr, { i18n: t, children: e }), kr = (e = "label") => {
  const t = Array.isArray(e) ? e : [e];
  return hr(t);
}, Er = () => {
  const { t: e } = kr("label");
  return /* @__PURE__ */ w("div", { "data-testid": "default-loading-fallback", children: e("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
};
var xe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ye(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
const Dr = "application/json", Ca = "Content-Type", Se = Symbol(), _a = Symbol();
function Vt(e = {}) {
  var t;
  const a = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(a).find(([r]) => r.toLowerCase() === Ca.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function Jt(e) {
  return /^application\/.*json.*/.test(e);
}
const _e = function(e, t, a = !1) {
  return Object.entries(t).reduce((r, [n, o]) => {
    const s = e[n];
    return Array.isArray(s) && Array.isArray(o) ? r[n] = a ? [...s, ...o] : o : typeof s == "object" && typeof o == "object" ? r[n] = _e(s, o, a) : r[n] = o, r;
  }, { ...e });
}, Ne = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, a = !1, ...r) {
    const n = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !n)
      throw new Error(e + " is not defined");
    return a && n ? new n(...r) : n;
  }
};
function Tr(e, t = !1) {
  Ne.options = t ? e : _e(Ne.options, e);
}
function $r(e, t = !1) {
  Ne.polyfills = t ? e : _e(Ne.polyfills, e);
}
function Sr(e) {
  Ne.errorType = e;
}
const Wr = (e) => (t) => e.reduceRight((a, r) => r(a), t) || t;
class ka extends Error {
}
const Nr = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((m, c) => c.beforeRequest && c.beforeRequest(m, e._options, t) || m, e);
  const { _url: a, _options: r, _config: n, _catchers: o, _resolvers: s, _middlewares: i, _addons: l } = e, d = new Map(o), u = _e(n.options, r);
  let g = a;
  const M = Wr(i)((m, c) => (g = m, n.polyfill("fetch")(m, c)))(a, u), b = new Error(), P = M.catch((m) => {
    throw { [Se]: m };
  }).then((m) => {
    var c;
    if (!m.ok) {
      const v = new ka();
      if (v.cause = b, v.stack = v.stack + `
CAUSE: ` + b.stack, v.response = m, v.status = m.status, v.url = g, m.type === "opaque")
        throw v;
      const x = n.errorType === "json" || ((c = m.headers.get("Content-Type")) === null || c === void 0 ? void 0 : c.split(";")[0]) === "application/json";
      return (n.errorType ? x ? m.text() : m[n.errorType]() : Promise.resolve(m.body)).then((U) => {
        throw v.message = typeof U == "string" ? U : m.statusText, U && (x && typeof U == "string" ? (v.text = U, v.json = JSON.parse(U)) : v[n.errorType] = U), v;
      });
    }
    return m;
  }), k = (m) => m.catch((c) => {
    const v = Object.prototype.hasOwnProperty.call(c, Se), x = v ? c[Se] : c, S = (x == null ? void 0 : x.status) && d.get(x.status) || d.get(x == null ? void 0 : x.name) || v && d.has(Se) && d.get(Se);
    if (S)
      return S(x, e);
    const U = d.get(_a);
    if (U)
      return U(x, e);
    throw x;
  }), p = (m) => (c) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ k(m ? P.then((v) => v && v[m]()).then((v) => c ? c(v) : v) : P.then((v) => c ? c(v) : v)), f = {
    _wretchReq: e,
    _fetchReq: M,
    _sharedState: t,
    res: p(null),
    json: p("json"),
    blob: p("blob"),
    formData: p("formData"),
    arrayBuffer: p("arrayBuffer"),
    text: p("text"),
    error(m, c) {
      return d.set(m, c), this;
    },
    badRequest(m) {
      return this.error(400, m);
    },
    unauthorized(m) {
      return this.error(401, m);
    },
    forbidden(m) {
      return this.error(403, m);
    },
    notFound(m) {
      return this.error(404, m);
    },
    timeout(m) {
      return this.error(408, m);
    },
    internalError(m) {
      return this.error(500, m);
    },
    fetchError(m) {
      return this.error(Se, m);
    }
  }, h = l.reduce((m, c) => ({
    ...m,
    ...typeof c.resolver == "function" ? c.resolver(m) : c.resolver
  }), f);
  return s.reduce((m, c) => c(m, e), h);
}, Or = {
  _url: "",
  _options: {},
  _config: Ne,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : _e(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const a = this._url.split("?");
    return {
      ...this,
      _url: a.length > 1 ? a[0] + e + "?" + a[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : _e(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: _e(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [Ca]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const a = new Map(this._catchers);
    return a.set(e, t), { ...this, _catchers: a };
  },
  catcherFallback(e) {
    return this.catcher(_a, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", a = null) {
    let r = this.url(t).options({ method: e });
    const n = Vt(r._options.headers), o = this._config.polyfill("FormData", !1), s = typeof a == "object" && !(o && a instanceof o) && (!r._options.headers || !n || Jt(n));
    return r = a ? s ? r.json(a, n) : r.body(a) : r, Nr(r._deferred.reduce((i, l) => l(i, i._url, i._options), r));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const a = Vt(this._options.headers);
    return this.content(t || Jt(a) && a || Dr).body(JSON.stringify(e));
  }
};
function Me(e = "", t = {}) {
  return { ...Or, _url: e, _options: t };
}
Me.default = Me;
Me.options = Tr;
Me.errorType = Sr;
Me.polyfills = $r;
Me.WretchError = ka;
class jr extends Error {
  constructor(a, r, n, o, s) {
    super(a);
    ye(this, "statusCode");
    ye(this, "endpoint");
    ye(this, "args");
    ye(this, "response");
    this.name = "ApiError", this.statusCode = r, this.endpoint = n, this.args = o, this.response = s;
  }
}
class At extends jr {
  constructor(t, a, r, n) {
    super(`Client error ${t} occurred while fetching ${a}`, t, a, r, n), this.name = "Api4xxError";
  }
}
class zr extends At {
  constructor(t, a, r) {
    super(404, t, a, r), this.name = "Api404Error";
  }
}
class Lr extends At {
  constructor(t, a, r) {
    super(400, t, a, r), this.name = "Api400Error";
  }
}
class Hr {
  constructor(t = {}) {
    ye(this, "logger");
    ye(this, "notFoundLogLevel");
    ye(this, "badRequestLogLevel");
    ye(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, a, r) {
    this.logger && this.logger[t](a, r);
  }
  async handleApiError(t, a, r) {
    if (!(t instanceof Response))
      throw t;
    const { status: n } = t;
    if (n === 404) {
      const o = new zr(a, r, t);
      return this.log(this.notFoundLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    if (n === 400) {
      const o = new Lr(a, r, t);
      return this.log(this.badRequestLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    if (n >= 400 && n < 500) {
      const o = new At(n, a, r, t);
      return this.log(this.other4xxLogLevel, o.message, {
        args: r,
        endpoint: a,
        statusCode: n
      }), null;
    }
    throw t;
  }
}
const Rr = (e, t) => {
  const a = new Hr(t);
  return e.catcher(404, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(400, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(401, async (r) => (await a.handleApiError(r.response, r.url), null)).catcher(403, async (r) => (await a.handleApiError(r.response, r.url), null)).catcherFallback(async (r) => {
    if (r.status >= 400 && r.status < 500)
      return await a.handleApiError(r.response, r.url), null;
    throw r;
  });
};
/*! js-cookie v3.0.5 | MIT */
function Re(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t];
    for (var r in a)
      e[r] = a[r];
  }
  return e;
}
var Ar = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function et(e, t) {
  function a(n, o, s) {
    if (!(typeof document > "u")) {
      s = Re({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var l in s)
        s[l] && (i += "; " + l, s[l] !== !0 && (i += "=" + s[l].split(";")[0]));
      return document.cookie = n + "=" + e.write(o, n) + i;
    }
  }
  function r(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, i = 0; i < o.length; i++) {
        var l = o[i].split("="), d = l.slice(1).join("=");
        try {
          var u = decodeURIComponent(l[0]);
          if (s[u] = e.read(d, u), n === u)
            break;
        } catch {
        }
      }
      return n ? s[n] : s;
    }
  }
  return Object.create(
    {
      set: a,
      get: r,
      remove: function(n, o) {
        a(
          n,
          "",
          Re({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return et(this.converter, Re({}, this.attributes, n));
      },
      withConverter: function(n) {
        return et(Re({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
et(Ar, { path: "/" });
Ie({});
const Ea = (e) => {
  typeof window < "u" && (window.dataLayer = window.dataLayer || [], window.dataLayer.push({
    ...e
  }));
}, Da = {
  ARTICLE_CLICK: "article_click",
  HERO_ARTICLE_VIEW: "hero_article_view"
}, Fr = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx`, Ta = (e, t) => {
  const a = new URL(e);
  return a.searchParams.set("fm", "webp"), a.searchParams.set("w", t.toString()), a.toString();
}, Ir = [
  // GTM/Google Debug
  "gtm_debug",
  "debug",
  // Cache bypass
  "nocache",
  // Google Ads/Analytics
  "gclid",
  "gclsrc",
  "_gl",
  // UTM Campaign Tracking
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id"
];
function je(e, t) {
  if (!t && typeof window > "u")
    return e;
  try {
    const a = new URL(t || window.location.href), r = new URLSearchParams(a.search), n = [];
    for (const i of Ir) {
      const l = r.get(i);
      l !== null && n.push([i, l]);
    }
    if (n.length === 0)
      return e;
    const o = e.startsWith("http://") || e.startsWith("https://"), s = o ? new URL(e) : new URL(e, a.origin);
    for (const [i, l] of n)
      s.searchParams.has(i) || s.searchParams.set(i, l);
    return o ? s.toString() : s.pathname + s.search + s.hash;
  } catch {
    return e;
  }
}
const $a = async (e = Fr(), t, a) => {
  const { countryCode: r, limit: n, offset: o, repub: s, subdivision: i, topics: l, type: d } = t, u = new URL(`${e}/v2/articles`);
  return d && u.searchParams.append("articleType", d), n && u.searchParams.append("limit", n.toString()), o && u.searchParams.append("offset", o.toString()), l && u.searchParams.append("topics", l), Rr(
    Me(u.toString(), {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "country-code": r,
        repub: s,
        ...i ? { subdivision: i } : {},
        ...(a == null ? void 0 : a.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    a
  ).get().notFound(() => null).json();
}, Sa = ({
  countryCode: e,
  limit: t,
  repub: a,
  subdivision: r,
  topics: n,
  type: o
}) => ["more-articles", a, e, r, n, o, t];
var Yr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Wa(e) {
  var t, a, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var n = e.length;
      for (t = 0; t < n; t++)
        e[t] && (a = Wa(e[t])) && (r && (r += " "), r += a);
    } else
      for (a in e)
        e[a] && (r && (r += " "), r += a);
  return r;
}
function G() {
  for (var e, t, a = 0, r = "", n = arguments.length; a < n; a++)
    (e = arguments[a]) && (t = Wa(e)) && (r && (r += " "), r += t);
  return r;
}
const Qt = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Kt = G, Ur = (e, t) => (a) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return Kt(e, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
  const { variants: n, defaultVariants: o } = t, s = Object.keys(n).map((d) => {
    const u = a == null ? void 0 : a[d], g = o == null ? void 0 : o[d];
    if (u === null)
      return null;
    const M = Qt(u) || Qt(g);
    return n[d][M];
  }), i = a && Object.entries(a).reduce((d, u) => {
    let [g, M] = u;
    return M === void 0 || (d[g] = M), d;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, u) => {
    let { class: g, className: M, ...b } = u;
    return Object.entries(b).every((P) => {
      let [k, p] = P;
      return Array.isArray(p) ? p.includes({
        ...o,
        ...i
      }[k]) : {
        ...o,
        ...i
      }[k] === p;
    }) ? [
      ...d,
      g,
      M
    ] : d;
  }, []);
  return Kt(e, s, l, a == null ? void 0 : a.class, a == null ? void 0 : a.className);
}, Br = "_icon_1tv3o_1", me = {
  icon: Br,
  "size--xs": "_size--xs_1tv3o_5",
  "size--s": "_size--s_1tv3o_10",
  "size--m": "_size--m_1tv3o_15",
  "size--l": "_size--l_1tv3o_20",
  "size--xl": "_size--xl_1tv3o_25",
  "color--black": "_color--black_1tv3o_30",
  "color--white": "_color--white_1tv3o_34",
  "color--green": "_color--green_1tv3o_38",
  "color--blue": "_color--blue_1tv3o_42",
  "color--grey": "_color--grey_1tv3o_46"
}, re = Ur(me.icon, {
  variants: {
    color: {
      black: me["color--black"],
      white: me["color--white"],
      blue: me["color--blue"],
      green: me["color--green"],
      grey: me["color--grey"]
    },
    size: {
      xs: me["size--xs"],
      s: me["size--s"],
      m: me["size--m"],
      l: me["size--l"],
      xl: me["size--xl"]
    }
  },
  defaultVariants: {
    color: "white",
    size: "m"
  }
}), Xr = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 11, fill: "none", viewBox: "0 0 12 11", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "m.136 5.702 4.091 4.772c.178.249.546.248.773.045a.56.56 0 0 0 .045-.781L1.747 5.895h9.707c.301 0 .546-.251.546-.561s-.244-.561-.546-.561H1.747L5.045.93c.216-.215.156-.584-.071-.788s-.569-.189-.747.051L.136 4.965A.56.56 0 0 0 0 5.334c.01.119.059.279.136.368",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
Xr.displayName = "Arrow";
const Vr = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M16.5 1.838v14.999a.46.46 0 0 1-.248.413l-.18.046a.45.45 0 0 1-.316-.115l-1.735-1.631-.225.207v3.767a.46.46 0 0 1-.271.413l-.18.046a.45.45 0 0 1-.316-.115l-1.713-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.78-1.631-1.78 1.631a.443.443 0 0 1-.608 0l-1.758-1.631-1.735 1.631a.44.44 0 0 1-.487.097.46.46 0 0 1-.279-.418V4.548c0-1.015.807-1.838 1.803-1.838h.901v-.873C3.204.823 4.011 0 5.007 0h9.69c.996 0 1.803.823 1.803 1.838m-4.868 15.458 1.262 1.195V4.525a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v13.966l1.284-1.195a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.443.443 0 0 1 .608 0l1.78 1.631 1.78-1.631a.444.444 0 0 1 .609 0zm2.682-2.71 1.284 1.194-.023-13.943a.91.91 0 0 0-.901-.919h-9.69a.91.91 0 0 0-.901.919v.85h7.887c.996 0 1.803.823 1.803 1.838v9.992a.445.445 0 0 1 .541.069M4.976 8h3.048c.263 0 .476-.224.476-.5S8.287 7 8.024 7H4.976c-.263 0-.476.224-.476.5s.213.5.476.5m-.06 2h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5zm0 3h5.167c.23 0 .417.224.417.5s-.187.5-.417.5H4.917c-.23 0-.417-.224-.417-.5s.187-.5.417-.5z",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
Vr.displayName = "Betslip";
const tt = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 9, fill: "none", viewBox: "0 0 13 9", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 5.188 10.781.86 12.22 2.3 6.455 8.062.691 2.3 2.13.86z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
tt.displayName = "ChevronDown";
const Jr = H.forwardRef(
  ({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
    const s = G(
      re({
        color: e,
        size: t
      }),
      r
    ), i = {
      "--opacity": a
    };
    return H.cloneElement(
      /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ref: o, ...n, children: /* @__PURE__ */ X("g", { fill: "currentColor", children: [
        /* @__PURE__ */ w("path", { d: "M12 17.5a1 1 0 0 1-.707-.293l-9-9a1 1 0 1 1 1.414-1.414l9 9A1 1 0 0 1 12 17.5" }),
        /* @__PURE__ */ w("path", { d: "M12 17.5a1 1 0 0 1-.707-1.707l9-9a1 1 0 1 1 1.414 1.414l-9 9A1 1 0 0 1 12 17.5" })
      ] }) }),
      {
        role: "presentation",
        focusable: !1,
        className: s,
        "aria-hidden": !0,
        style: i,
        ...n
      }
    );
  }
);
Jr.displayName = "ChevronDownLight";
const Qr = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 8, fill: "none", viewBox: "0 0 13 8", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M6.455 3.017 2.129 7.344.69 5.906 6.455.143l5.764 5.763-1.438 1.438z",
        clipRule: "evenodd",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
Qr.displayName = "ChevronUp";
const Kr = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ X("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 13, fill: "none", viewBox: "0 0 13 13", ref: o, ...n, children: [
      /* @__PURE__ */ w("path", { fill: "currentColor", d: "M1.638.33 12.75 11.48l-1.265 1.27L.373 1.6z" }),
      /* @__PURE__ */ w("path", { fill: "currentColor", d: "M.25 11.379 11.34.25l1.265 1.27-11.09 11.128z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
Kr.displayName = "Cross";
const Zr = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M15.344 17.778a.75.75 0 0 0-.75-.75h-5.16a.75.75 0 1 0 0 1.5h5.16a.75.75 0 0 0 .75-.75m2.206-4a.75.75 0 0 0-.75-.75H7.204a.75.75 0 1 0 0 1.5H16.8a.75.75 0 0 0 .75-.75m2.45-4a.75.75 0 0 0-.75-.75H4.75a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 .75-.75m2-4a.75.75 0 0 0-.75-.75H2.75a.75.75 0 1 0 0 1.5h18.5a.75.75 0 0 0 .75-.75"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
Zr.displayName = "Filter";
const Gr = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 15, fill: "none", viewBox: "0 0 15 15", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M7.5 13.5a6 6 0 0 0 4.243-1.757A6 6 0 0 0 13.5 7.5a6 6 0 0 0-1.757-4.243A6 6 0 0 0 7.5 1.5a6 6 0 0 0-6 6 6 6 0 0 0 6 6m0 1.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 1 1 0 15m-.75-8.25v4.5h1.5v-4.5zm0-3h1.5v1.5h-1.5z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
Gr.displayName = "Info";
const en = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 17 16", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M1.423 0a.923.923 0 1 0 0 1.846h14.154a.923.923 0 1 0 0-1.846zM.5 7.692c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423A.923.923 0 0 1 .5 7.692m0 6.769c0-.51.413-.923.923-.923h14.154a.923.923 0 1 1 0 1.846H1.423a.923.923 0 0 1-.923-.923",
        fillRule: "evenodd"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
en.displayName = "Menu";
const tn = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ X(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        fill: "currentColor",
        viewBox: "0 0 19 18",
        ref: o,
        ...n,
        children: [
          /* @__PURE__ */ w("path", { d: "m6.361 11.888.359-.84a.4.4 0 0 1 .229-.222.4.4 0 0 1 .125-.022q.098 0 .185.049c.546.306 1.279.49 1.961.49.801 0 1.383-.345 1.383-.818 0-.306-.169-.676-1.415-1.102-1.35-.446-2.725-1.097-2.725-2.557 0-1.108.767-1.975 2.052-2.317l.195-.052v-.916c0-.224.177-.408.39-.408h.923a.4.4 0 0 1 .39.408v.823l.229.03a4.6 4.6 0 0 1 1.482.432c.094.047.166.129.2.232s.031.216-.013.312l-.372.829a.39.39 0 0 1-.354.235.4.4 0 0 1-.161-.038c-.242-.118-.809-.388-1.714-.388-.822 0-1.188.334-1.188.667 0 .372.382.624 1.578 1.039 1.274.438 2.575 1.097 2.575 2.683 0 .856-.564 2.008-2.156 2.429l-.195.055v.949c0 .227-.177.41-.39.41h-.939a.4.4 0 0 1-.39-.41V13l-.231-.025c-.718-.085-1.394-.29-1.849-.566a.42.42 0 0 1-.163-.522z" }),
          /* @__PURE__ */ w(
            "path",
            {
              d: "M18.228 8.727a8.73 8.73 0 0 1-8.727 8.727A8.73 8.73 0 0 1 .773 8.727 8.73 8.73 0 0 1 9.501 0a8.73 8.73 0 0 1 8.727 8.727m-1.091 0c0 4.382-3.255 7.636-7.636 7.636s-7.636-3.255-7.636-7.636S5.12 1.091 9.501 1.091s7.636 3.255 7.636 7.636",
              fillRule: "evenodd"
            }
          )
        ]
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
tn.displayName = "Offers";
const an = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ X("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 20, fill: "none", viewBox: "0 0 17 20", ref: o, ...n, children: [
      /* @__PURE__ */ w(
        "path",
        {
          stroke: "currentColor",
          d: "M8.62 12v2.5M1 7.927v10.391h15.24V7.928zm2.77 0C3.77 3.771 3.77 1 8.62 1s4.85 2.77 4.85 6.927z"
        }
      ),
      /* @__PURE__ */ w("path", { stroke: "currentColor", d: "M8.62 12.855a.693.693 0 1 0 0-1.386.693.693 0 0 0 0 1.386Z" })
    ] }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
an.displayName = "Padlock";
const rn = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 20, fill: "none", viewBox: "0 0 12 20", ref: o, ...n, children: /* @__PURE__ */ w("path", { stroke: "currentColor", d: "M4.9 11.119H1L8.8 1 6.85 8.738h3.9l-7.8 10.119z", strokeLinejoin: "round" }) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
rn.displayName = "Picks";
const nn = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 19, fill: "none", viewBox: "0 0 19 19", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        fill: "currentColor",
        d: "M9.048.949a.5.5 0 0 1 .903 0l2.45 5.151a.5.5 0 0 0 .387.281l5.656.738a.5.5 0 0 1 .279.859L14.581 11.9a.5.5 0 0 0-.148.455l1.046 5.607a.5.5 0 0 1-.731.531l-5.009-2.727a.5.5 0 0 0-.478 0l-5.009 2.727a.5.5 0 0 1-.731-.531l1.046-5.607a.5.5 0 0 0-.148-.455L.277 7.978a.5.5 0 0 1 .279-.859l5.656-.738a.5.5 0 0 0 .387-.281z"
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
nn.displayName = "Star";
const on = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w("svg", { xmlns: "http://www.w3.org/2000/svg", width: 22, height: 20, fill: "none", viewBox: "0 0 22 20", ref: o, ...n, children: /* @__PURE__ */ w(
      "path",
      {
        stroke: "currentColor",
        d: "M15.965 4.968c0 2.372-2.081 4.368-4.743 4.368S6.478 7.34 6.478 4.968 8.56.6 11.222.6s4.743 1.996 4.743 4.368ZM15.318 10.857c.174-.116.314-.182.435-.205 1.448-.273 2.575.594 3.49 2.15.906 1.543 1.472 3.573 1.799 5.122.16.758-.429 1.476-1.275 1.476H1.863c-.75 0-1.265-.556-1.207-1.185.222-2.425 1.23-6.34 5.288-7.684.275-.091.607-.059.935.095 1.852.867 3.42 1.291 4.805 1.31 1.4.02 2.577-.374 3.634-1.079Z",
        strokeWidth: 1.2
      }
    ) }),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
on.displayName = "Account";
const sn = H.forwardRef(({ color: e, size: t, opacity: a = 1, className: r, ...n }, o) => {
  const s = G(
    re({
      color: e,
      size: t
    }),
    r
  ), i = {
    "--opacity": a
  };
  return H.cloneElement(
    /* @__PURE__ */ w(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12.78,
        height: 9.58,
        fill: "none",
        viewBox: "0 0 12.78 9.58",
        ref: o,
        ...n,
        children: /* @__PURE__ */ w("path", { fill: "currentColor", d: "m10.538 0 1.637 1.678-7.987 7.795-4.188-4L1.62 3.78l2.55 2.436z" })
      }
    ),
    {
      role: "presentation",
      focusable: !1,
      className: s,
      "aria-hidden": !0,
      style: i,
      ...n
    }
  );
});
sn.displayName = "Check";
var Na = { exports: {} };
(function(e, t) {
  (function(a, r) {
    e.exports = r(H);
  })(Yr, (a) => (() => {
    var r = { 703: (i, l, d) => {
      var u = d(414);
      function g() {
      }
      function M() {
      }
      M.resetWarningCache = g, i.exports = function() {
        function b(p, f, h, m, c, v) {
          if (v !== u) {
            var x = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw x.name = "Invariant Violation", x;
          }
        }
        function P() {
          return b;
        }
        b.isRequired = b;
        var k = { array: b, bigint: b, bool: b, func: b, number: b, object: b, string: b, symbol: b, any: b, arrayOf: P, element: b, elementType: b, instanceOf: P, node: b, objectOf: P, oneOf: P, oneOfType: P, shape: P, exact: P, checkPropTypes: M, resetWarningCache: g };
        return k.PropTypes = k, k;
      };
    }, 697: (i, l, d) => {
      i.exports = d(703)();
    }, 414: (i) => {
      i.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, 98: (i) => {
      i.exports = a;
    } }, n = {};
    function o(i) {
      var l = n[i];
      if (l !== void 0)
        return l.exports;
      var d = n[i] = { exports: {} };
      return r[i](d, d.exports, o), d.exports;
    }
    o.n = (i) => {
      var l = i && i.__esModule ? () => i.default : () => i;
      return o.d(l, { a: l }), l;
    }, o.d = (i, l) => {
      for (var d in l)
        o.o(l, d) && !o.o(i, d) && Object.defineProperty(i, d, { enumerable: !0, get: l[d] });
    }, o.o = (i, l) => Object.prototype.hasOwnProperty.call(i, l), o.r = (i) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
    };
    var s = {};
    return (() => {
      o.r(s), o.d(s, { default: () => Ce });
      var i = o(98), l = o.n(i), d = o(697), u = o.n(d);
      function g() {
        return g = Object.assign ? Object.assign.bind() : function(E) {
          for (var C = 1; C < arguments.length; C++) {
            var O = arguments[C];
            for (var j in O)
              Object.prototype.hasOwnProperty.call(O, j) && (E[j] = O[j]);
          }
          return E;
        }, g.apply(this, arguments);
      }
      var M = function(E) {
        var C = E.pageClassName, O = E.pageLinkClassName, j = E.page, ee = E.selected, V = E.activeClassName, J = E.activeLinkClassName, _ = E.getEventListener, y = E.pageSelectedHandler, L = E.href, D = E.extraAriaContext, N = E.pageLabelBuilder, z = E.rel, F = E.ariaLabel || "Page " + j + (D ? " " + D : ""), Q = null;
        return ee && (Q = "page", F = E.ariaLabel || "Page " + j + " is your current page", C = C !== void 0 ? C + " " + V : V, O !== void 0 ? J !== void 0 && (O = O + " " + J) : O = J), l().createElement("li", { className: C }, l().createElement("a", g({ rel: z, role: L ? void 0 : "button", className: O, href: L, tabIndex: ee ? "-1" : "0", "aria-label": F, "aria-current": Q, onKeyPress: y }, _(y)), N(j)));
      };
      M.propTypes = { pageSelectedHandler: u().func.isRequired, selected: u().bool.isRequired, pageClassName: u().string, pageLinkClassName: u().string, activeClassName: u().string, activeLinkClassName: u().string, extraAriaContext: u().string, href: u().string, ariaLabel: u().string, page: u().number.isRequired, getEventListener: u().func.isRequired, pageLabelBuilder: u().func.isRequired, rel: u().string };
      const b = M;
      function P() {
        return P = Object.assign ? Object.assign.bind() : function(E) {
          for (var C = 1; C < arguments.length; C++) {
            var O = arguments[C];
            for (var j in O)
              Object.prototype.hasOwnProperty.call(O, j) && (E[j] = O[j]);
          }
          return E;
        }, P.apply(this, arguments);
      }
      var k = function(E) {
        var C = E.breakLabel, O = E.breakAriaLabel, j = E.breakClassName, ee = E.breakLinkClassName, V = E.breakHandler, J = E.getEventListener, _ = j || "break";
        return l().createElement("li", { className: _ }, l().createElement("a", P({ className: ee, role: "button", tabIndex: "0", "aria-label": O, onKeyPress: V }, J(V)), C));
      };
      k.propTypes = { breakLabel: u().oneOfType([u().string, u().node]), breakAriaLabel: u().string, breakClassName: u().string, breakLinkClassName: u().string, breakHandler: u().func.isRequired, getEventListener: u().func.isRequired };
      const p = k;
      function f(E) {
        var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return E ?? C;
      }
      function h(E) {
        return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
          return typeof C;
        } : function(C) {
          return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
        }, h(E);
      }
      function m() {
        return m = Object.assign ? Object.assign.bind() : function(E) {
          for (var C = 1; C < arguments.length; C++) {
            var O = arguments[C];
            for (var j in O)
              Object.prototype.hasOwnProperty.call(O, j) && (E[j] = O[j]);
          }
          return E;
        }, m.apply(this, arguments);
      }
      function c(E, C) {
        for (var O = 0; O < C.length; O++) {
          var j = C[O];
          j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(E, j.key, j);
        }
      }
      function v(E, C) {
        return v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(O, j) {
          return O.__proto__ = j, O;
        }, v(E, C);
      }
      function x(E, C) {
        if (C && (h(C) === "object" || typeof C == "function"))
          return C;
        if (C !== void 0)
          throw new TypeError("Derived constructors may only return object or undefined");
        return S(E);
      }
      function S(E) {
        if (E === void 0)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return E;
      }
      function U(E) {
        return U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(C) {
          return C.__proto__ || Object.getPrototypeOf(C);
        }, U(E);
      }
      function R(E, C, O) {
        return C in E ? Object.defineProperty(E, C, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : E[C] = O, E;
      }
      var de = function(E) {
        (function(_, y) {
          if (typeof y != "function" && y !== null)
            throw new TypeError("Super expression must either be null or a function");
          _.prototype = Object.create(y && y.prototype, { constructor: { value: _, writable: !0, configurable: !0 } }), Object.defineProperty(_, "prototype", { writable: !1 }), y && v(_, y);
        })(J, E);
        var C, O, j, ee, V = (j = J, ee = function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }(), function() {
          var _, y = U(j);
          if (ee) {
            var L = U(this).constructor;
            _ = Reflect.construct(y, arguments, L);
          } else
            _ = y.apply(this, arguments);
          return x(this, _);
        });
        function J(_) {
          var y, L;
          return function(D, N) {
            if (!(D instanceof N))
              throw new TypeError("Cannot call a class as a function");
          }(this, J), R(S(y = V.call(this, _)), "handlePreviousPage", function(D) {
            var N = y.state.selected;
            y.handleClick(D, null, N > 0 ? N - 1 : void 0, { isPrevious: !0 });
          }), R(S(y), "handleNextPage", function(D) {
            var N = y.state.selected, z = y.props.pageCount;
            y.handleClick(D, null, N < z - 1 ? N + 1 : void 0, { isNext: !0 });
          }), R(S(y), "handlePageSelected", function(D, N) {
            if (y.state.selected === D)
              return y.callActiveCallback(D), void y.handleClick(N, null, void 0, { isActive: !0 });
            y.handleClick(N, null, D);
          }), R(S(y), "handlePageChange", function(D) {
            y.state.selected !== D && (y.setState({ selected: D }), y.callCallback(D));
          }), R(S(y), "getEventListener", function(D) {
            return R({}, y.props.eventListener, D);
          }), R(S(y), "handleClick", function(D, N, z) {
            var F = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, Q = F.isPrevious, Z = Q !== void 0 && Q, le = F.isNext, pe = le !== void 0 && le, ue = F.isBreak, K = ue !== void 0 && ue, ce = F.isActive, fe = ce !== void 0 && ce;
            D.preventDefault ? D.preventDefault() : D.returnValue = !1;
            var he = y.state.selected, Y = y.props.onClick, A = z;
            if (Y) {
              var B = Y({ index: N, selected: he, nextSelectedPage: z, event: D, isPrevious: Z, isNext: pe, isBreak: K, isActive: fe });
              if (B === !1)
                return;
              Number.isInteger(B) && (A = B);
            }
            A !== void 0 && y.handlePageChange(A);
          }), R(S(y), "handleBreakClick", function(D, N) {
            var z = y.state.selected;
            y.handleClick(N, D, z < D ? y.getForwardJump() : y.getBackwardJump(), { isBreak: !0 });
          }), R(S(y), "callCallback", function(D) {
            y.props.onPageChange !== void 0 && typeof y.props.onPageChange == "function" && y.props.onPageChange({ selected: D });
          }), R(S(y), "callActiveCallback", function(D) {
            y.props.onPageActive !== void 0 && typeof y.props.onPageActive == "function" && y.props.onPageActive({ selected: D });
          }), R(S(y), "getElementPageRel", function(D) {
            var N = y.state.selected, z = y.props, F = z.nextPageRel, Q = z.prevPageRel, Z = z.selectedPageRel;
            return N - 1 === D ? Q : N === D ? Z : N + 1 === D ? F : void 0;
          }), R(S(y), "pagination", function() {
            var D = [], N = y.props, z = N.pageRangeDisplayed, F = N.pageCount, Q = N.marginPagesDisplayed, Z = N.breakLabel, le = N.breakClassName, pe = N.breakLinkClassName, ue = N.breakAriaLabels, K = y.state.selected;
            if (F <= z)
              for (var ce = 0; ce < F; ce++)
                D.push(y.getPageElement(ce));
            else {
              var fe = z / 2, he = z - fe;
              K > F - z / 2 ? fe = z - (he = F - K) : K < z / 2 && (he = z - (fe = K));
              var Y, A, B = function(we) {
                return y.getPageElement(we);
              }, I = [];
              for (Y = 0; Y < F; Y++) {
                var Le = Y + 1;
                if (Le <= Q)
                  I.push({ type: "page", index: Y, display: B(Y) });
                else if (Le > F - Q)
                  I.push({ type: "page", index: Y, display: B(Y) });
                else if (Y >= K - fe && Y <= K + (K === 0 && z > 1 ? he - 1 : he))
                  I.push({ type: "page", index: Y, display: B(Y) });
                else if (Z && I.length > 0 && I[I.length - 1].display !== A && (z > 0 || Q > 0)) {
                  var qe = Y < K ? ue.backward : ue.forward;
                  A = l().createElement(p, { key: Y, breakAriaLabel: qe, breakLabel: Z, breakClassName: le, breakLinkClassName: pe, breakHandler: y.handleBreakClick.bind(null, Y), getEventListener: y.getEventListener }), I.push({ type: "break", index: Y, display: A });
                }
              }
              I.forEach(function(we, Pe) {
                var He = we;
                we.type === "break" && I[Pe - 1] && I[Pe - 1].type === "page" && I[Pe + 1] && I[Pe + 1].type === "page" && I[Pe + 1].index - I[Pe - 1].index <= 2 && (He = { type: "page", index: we.index, display: B(we.index) }), D.push(He.display);
              });
            }
            return D;
          }), _.initialPage !== void 0 && _.forcePage !== void 0 && console.warn("(react-paginate): Both initialPage (".concat(_.initialPage, ") and forcePage (").concat(_.forcePage, ") props are provided, which is discouraged.") + ` Use exclusively forcePage prop for a controlled component.
See https://reactjs.org/docs/forms.html#controlled-components`), L = _.initialPage ? _.initialPage : _.forcePage ? _.forcePage : 0, y.state = { selected: L }, y;
        }
        return C = J, (O = [{ key: "componentDidMount", value: function() {
          var _ = this.props, y = _.initialPage, L = _.disableInitialCallback, D = _.extraAriaContext, N = _.pageCount, z = _.forcePage;
          y === void 0 || L || this.callCallback(y), D && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(N) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(N, "). Did you forget a Math.ceil()?")), y !== void 0 && y > N - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(y, " > ").concat(N - 1, ").")), z !== void 0 && z > N - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(z, " > ").concat(N - 1, ")."));
        } }, { key: "componentDidUpdate", value: function(_) {
          this.props.forcePage !== void 0 && this.props.forcePage !== _.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({ selected: this.props.forcePage })), Number.isInteger(_.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
        } }, { key: "getForwardJump", value: function() {
          var _ = this.state.selected, y = this.props, L = y.pageCount, D = _ + y.pageRangeDisplayed;
          return D >= L ? L - 1 : D;
        } }, { key: "getBackwardJump", value: function() {
          var _ = this.state.selected - this.props.pageRangeDisplayed;
          return _ < 0 ? 0 : _;
        } }, { key: "getElementHref", value: function(_) {
          var y = this.props, L = y.hrefBuilder, D = y.pageCount, N = y.hrefAllControls;
          if (L)
            return N || _ >= 0 && _ < D ? L(_ + 1, D, this.state.selected) : void 0;
        } }, { key: "ariaLabelBuilder", value: function(_) {
          var y = _ === this.state.selected;
          if (this.props.ariaLabelBuilder && _ >= 0 && _ < this.props.pageCount) {
            var L = this.props.ariaLabelBuilder(_ + 1, y);
            return this.props.extraAriaContext && !y && (L = L + " " + this.props.extraAriaContext), L;
          }
        } }, { key: "getPageElement", value: function(_) {
          var y = this.state.selected, L = this.props, D = L.pageClassName, N = L.pageLinkClassName, z = L.activeClassName, F = L.activeLinkClassName, Q = L.extraAriaContext, Z = L.pageLabelBuilder;
          return l().createElement(b, { key: _, pageSelectedHandler: this.handlePageSelected.bind(null, _), selected: y === _, rel: this.getElementPageRel(_), pageClassName: D, pageLinkClassName: N, activeClassName: z, activeLinkClassName: F, extraAriaContext: Q, href: this.getElementHref(_), ariaLabel: this.ariaLabelBuilder(_), page: _ + 1, pageLabelBuilder: Z, getEventListener: this.getEventListener });
        } }, { key: "render", value: function() {
          var _ = this.props.renderOnZeroPageCount;
          if (this.props.pageCount === 0 && _ !== void 0)
            return _ && _(this.props);
          var y = this.props, L = y.disabledClassName, D = y.disabledLinkClassName, N = y.pageCount, z = y.className, F = y.containerClassName, Q = y.previousLabel, Z = y.previousClassName, le = y.previousLinkClassName, pe = y.previousAriaLabel, ue = y.prevRel, K = y.nextLabel, ce = y.nextClassName, fe = y.nextLinkClassName, he = y.nextAriaLabel, Y = y.nextRel, A = this.state.selected, B = A === 0, I = A === N - 1, Le = "".concat(f(Z)).concat(B ? " ".concat(f(L)) : ""), qe = "".concat(f(ce)).concat(I ? " ".concat(f(L)) : ""), we = "".concat(f(le)).concat(B ? " ".concat(f(D)) : ""), Pe = "".concat(f(fe)).concat(I ? " ".concat(f(D)) : ""), He = B ? "true" : "false", Za = I ? "true" : "false";
          return l().createElement("ul", { className: z || F, role: "navigation", "aria-label": "Pagination" }, l().createElement("li", { className: Le }, l().createElement("a", m({ className: we, href: this.getElementHref(A - 1), tabIndex: B ? "-1" : "0", role: "button", onKeyPress: this.handlePreviousPage, "aria-disabled": He, "aria-label": pe, rel: ue }, this.getEventListener(this.handlePreviousPage)), Q)), this.pagination(), l().createElement("li", { className: qe }, l().createElement("a", m({ className: Pe, href: this.getElementHref(A + 1), tabIndex: I ? "-1" : "0", role: "button", onKeyPress: this.handleNextPage, "aria-disabled": Za, "aria-label": he, rel: Y }, this.getEventListener(this.handleNextPage)), K)));
        } }]) && c(C.prototype, O), Object.defineProperty(C, "prototype", { writable: !1 }), J;
      }(i.Component);
      R(de, "propTypes", { pageCount: u().number.isRequired, pageRangeDisplayed: u().number, marginPagesDisplayed: u().number, previousLabel: u().node, previousAriaLabel: u().string, prevPageRel: u().string, prevRel: u().string, nextLabel: u().node, nextAriaLabel: u().string, nextPageRel: u().string, nextRel: u().string, breakLabel: u().oneOfType([u().string, u().node]), breakAriaLabels: u().shape({ forward: u().string, backward: u().string }), hrefBuilder: u().func, hrefAllControls: u().bool, onPageChange: u().func, onPageActive: u().func, onClick: u().func, initialPage: u().number, forcePage: u().number, disableInitialCallback: u().bool, containerClassName: u().string, className: u().string, pageClassName: u().string, pageLinkClassName: u().string, pageLabelBuilder: u().func, activeClassName: u().string, activeLinkClassName: u().string, previousClassName: u().string, nextClassName: u().string, previousLinkClassName: u().string, nextLinkClassName: u().string, disabledClassName: u().string, disabledLinkClassName: u().string, breakClassName: u().string, breakLinkClassName: u().string, extraAriaContext: u().string, ariaLabelBuilder: u().func, eventListener: u().string, renderOnZeroPageCount: u().func, selectedPageRel: u().string }), R(de, "defaultProps", { pageRangeDisplayed: 2, marginPagesDisplayed: 3, activeClassName: "selected", previousLabel: "Previous", previousClassName: "previous", previousAriaLabel: "Previous page", prevPageRel: "prev", prevRel: "prev", nextLabel: "Next", nextClassName: "next", nextAriaLabel: "Next page", nextPageRel: "next", nextRel: "next", breakLabel: "...", breakAriaLabels: { forward: "Jump forward", backward: "Jump backward" }, disabledClassName: "disabled", disableInitialCallback: !1, pageLabelBuilder: function(E) {
        return E;
      }, eventListener: "onClick", renderOnZeroPageCount: void 0, selectedPageRel: "canonical", hrefAllControls: !1 });
      const Ce = de;
    })(), s;
  })());
})(Na);
var ln = Na.exports;
const dn = /* @__PURE__ */ qr(ln), un = "320px", mn = "600px", cn = "1025px", fn = "_isVisuallyHidden_1oamq_52", hn = "_Pagination_1oamq_64", vn = "_paginationContainer_1oamq_68", gn = "_pageItem_1oamq_74", pn = "_pageItemDisabled_1oamq_96", yn = "_active_1oamq_118", bn = "_breakEllipsis_1oamq_122", Mn = "_previousIcon_1oamq_144", wn = "_nextIcon_1oamq_148", Pn = "_labelWrapper_1oamq_152", xn = "_labelText_1oamq_158", te = {
  mobile: un,
  "mobile-wide": "480px",
  tablet: mn,
  "tablet-wide": "800px",
  desktop: cn,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: fn,
  Pagination: hn,
  paginationContainer: vn,
  pageItem: gn,
  pageItemDisabled: pn,
  active: yn,
  breakEllipsis: bn,
  previousIcon: Mn,
  nextIcon: wn,
  labelWrapper: Pn,
  labelText: xn
}, Cn = ({
  forcePage: e,
  pageCount: t,
  onPageChange: a,
  hrefBuilder: r,
  previousLabel: n,
  nextLabel: o,
  ...s
}) => {
  const i = typeof e == "number" ? e + 1 : 1, l = i === 1, d = i === t, u = l ? te.pageItemDisabled : te.pageItem, g = l ? "grey" : "black", M = d ? te.pageItemDisabled : te.pageItem, b = d ? "grey" : "black";
  return /* @__PURE__ */ w("div", { className: te.Pagination, "data-testid": "pagination", children: /* @__PURE__ */ w(
    dn,
    {
      forcePage: e,
      pageCount: t,
      onPageChange: a,
      containerClassName: te.paginationContainer,
      pageClassName: te.pageItem,
      previousClassName: u,
      nextClassName: M,
      activeClassName: te.active,
      breakClassName: te.breakEllipsis,
      previousLabel: /* @__PURE__ */ X("div", { className: te.labelWrapper, "data-testid": "previous-page-button", children: [
        /* @__PURE__ */ w(tt, { className: te.previousIcon, color: g, size: "xs" }),
        n ? /* @__PURE__ */ w("span", { className: te.labelText, children: n }) : null
      ] }),
      nextLabel: /* @__PURE__ */ X("div", { className: te.labelWrapper, "data-testid": "next-page-button", children: [
        o ? /* @__PURE__ */ w("span", { className: te.labelText, children: o }) : null,
        /* @__PURE__ */ w(tt, { className: te.nextIcon, color: b, size: "xs" })
      ] }),
      marginPagesDisplayed: 1,
      pageRangeDisplayed: 2,
      renderOnZeroPageCount: null,
      pageLinkClassName: "page-link",
      hrefBuilder: r,
      ...s
    }
  ) });
};
var at = { exports: {} }, Oa = { exports: {} };
(function(e) {
  function t(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Oa);
var q = Oa.exports, rt = { exports: {} }, nt = { exports: {} }, ja = { exports: {} };
(function(e) {
  function t(a) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(a);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ja);
var za = ja.exports, ot = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r, n) {
    if (n.length < r)
      throw new TypeError(r + " argument" + (r > 1 ? "s" : "") + " required, but only " + n.length + " present");
  }
  e.exports = t.default;
})(ot, ot.exports);
var ne = ot.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(za), n = a(ne);
  function o(s) {
    return (0, n.default)(1, arguments), s instanceof Date || (0, r.default)(s) === "object" && Object.prototype.toString.call(s) === "[object Date]";
  }
  e.exports = t.default;
})(nt, nt.exports);
var _n = nt.exports, it = { exports: {} };
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(za), n = a(ne);
  function o(s) {
    (0, n.default)(1, arguments);
    var i = Object.prototype.toString.call(s);
    return s instanceof Date || (0, r.default)(s) === "object" && i === "[object Date]" ? new Date(s.getTime()) : typeof s == "number" || i === "[object Number]" ? new Date(s) : ((typeof s == "string" || i === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  e.exports = t.default;
})(it, it.exports);
var ve = it.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(_n), n = a(ve), o = a(ne);
  function s(i) {
    if ((0, o.default)(1, arguments), !(0, r.default)(i) && typeof i != "number")
      return !1;
    var l = (0, n.default)(i);
    return !isNaN(Number(l));
  }
  e.exports = t.default;
})(rt, rt.exports);
var kn = rt.exports, st = { exports: {} }, lt = { exports: {} }, dt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var n = Number(r);
    return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
  }
  e.exports = t.default;
})(dt, dt.exports);
var ke = dt.exports;
const En = /* @__PURE__ */ Ye(ke);
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(ke), n = a(ve), o = a(ne);
  function s(i, l) {
    (0, o.default)(2, arguments);
    var d = (0, n.default)(i).getTime(), u = (0, r.default)(l);
    return new Date(d + u);
  }
  e.exports = t.default;
})(lt, lt.exports);
var Dn = lt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(Dn), n = a(ne), o = a(ke);
  function s(i, l) {
    (0, n.default)(2, arguments);
    var d = (0, o.default)(l);
    return (0, r.default)(i, -d);
  }
  e.exports = t.default;
})(st, st.exports);
var Tn = st.exports, ut = { exports: {} }, mt = { exports: {} };
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(ve), n = a(ne), o = 864e5;
  function s(i) {
    (0, n.default)(1, arguments);
    var l = (0, r.default)(i), d = l.getTime();
    l.setUTCMonth(0, 1), l.setUTCHours(0, 0, 0, 0);
    var u = l.getTime(), g = d - u;
    return Math.floor(g / o) + 1;
  }
  e.exports = t.default;
})(mt, mt.exports);
var $n = mt.exports, ct = { exports: {} }, ft = { exports: {} };
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = o;
  var r = a(ve), n = a(ne);
  function o(s) {
    (0, n.default)(1, arguments);
    var i = 1, l = (0, r.default)(s), d = l.getUTCDay(), u = (d < i ? 7 : 0) + d - i;
    return l.setUTCDate(l.getUTCDate() - u), l.setUTCHours(0, 0, 0, 0), l;
  }
  e.exports = t.default;
})(ft, ft.exports);
var Ft = ft.exports, ht = { exports: {} }, vt = { exports: {} };
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(ve), n = a(ne), o = a(Ft);
  function s(i) {
    (0, n.default)(1, arguments);
    var l = (0, r.default)(i), d = l.getUTCFullYear(), u = /* @__PURE__ */ new Date(0);
    u.setUTCFullYear(d + 1, 0, 4), u.setUTCHours(0, 0, 0, 0);
    var g = (0, o.default)(u), M = /* @__PURE__ */ new Date(0);
    M.setUTCFullYear(d, 0, 4), M.setUTCHours(0, 0, 0, 0);
    var b = (0, o.default)(M);
    return l.getTime() >= g.getTime() ? d + 1 : l.getTime() >= b.getTime() ? d : d - 1;
  }
  e.exports = t.default;
})(vt, vt.exports);
var La = vt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var r = a(La), n = a(Ft), o = a(ne);
  function s(i) {
    (0, o.default)(1, arguments);
    var l = (0, r.default)(i), d = /* @__PURE__ */ new Date(0);
    d.setUTCFullYear(l, 0, 4), d.setUTCHours(0, 0, 0, 0);
    var u = (0, n.default)(d);
    return u;
  }
  e.exports = t.default;
})(ht, ht.exports);
var Sn = ht.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(ve), n = a(Ft), o = a(Sn), s = a(ne), i = 6048e5;
  function l(d) {
    (0, s.default)(1, arguments);
    var u = (0, r.default)(d), g = (0, n.default)(u).getTime() - (0, o.default)(u).getTime();
    return Math.round(g / i) + 1;
  }
  e.exports = t.default;
})(ct, ct.exports);
var Wn = ct.exports, gt = { exports: {} }, pt = { exports: {} }, Ee = {};
Object.defineProperty(Ee, "__esModule", {
  value: !0
});
Ee.getDefaultOptions = Nn;
Ee.setDefaultOptions = On;
var Ha = {};
function Nn() {
  return Ha;
}
function On(e) {
  Ha = e;
}
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var r = a(ve), n = a(ne), o = a(ke), s = Ee;
  function i(l, d) {
    var u, g, M, b, P, k, p, f;
    (0, n.default)(1, arguments);
    var h = (0, s.getDefaultOptions)(), m = (0, o.default)((u = (g = (M = (b = d == null ? void 0 : d.weekStartsOn) !== null && b !== void 0 ? b : d == null || (P = d.locale) === null || P === void 0 || (k = P.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && M !== void 0 ? M : h.weekStartsOn) !== null && g !== void 0 ? g : (p = h.locale) === null || p === void 0 || (f = p.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && u !== void 0 ? u : 0);
    if (!(m >= 0 && m <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var c = (0, r.default)(l), v = c.getUTCDay(), x = (v < m ? 7 : 0) + v - m;
    return c.setUTCDate(c.getUTCDate() - x), c.setUTCHours(0, 0, 0, 0), c;
  }
  e.exports = t.default;
})(pt, pt.exports);
var It = pt.exports, yt = { exports: {} }, bt = { exports: {} };
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(ve), n = a(ne), o = a(It), s = a(ke), i = Ee;
  function l(d, u) {
    var g, M, b, P, k, p, f, h;
    (0, n.default)(1, arguments);
    var m = (0, r.default)(d), c = m.getUTCFullYear(), v = (0, i.getDefaultOptions)(), x = (0, s.default)((g = (M = (b = (P = u == null ? void 0 : u.firstWeekContainsDate) !== null && P !== void 0 ? P : u == null || (k = u.locale) === null || k === void 0 || (p = k.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && b !== void 0 ? b : v.firstWeekContainsDate) !== null && M !== void 0 ? M : (f = v.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && g !== void 0 ? g : 1);
    if (!(x >= 1 && x <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var S = /* @__PURE__ */ new Date(0);
    S.setUTCFullYear(c + 1, 0, x), S.setUTCHours(0, 0, 0, 0);
    var U = (0, o.default)(S, u), R = /* @__PURE__ */ new Date(0);
    R.setUTCFullYear(c, 0, x), R.setUTCHours(0, 0, 0, 0);
    var de = (0, o.default)(R, u);
    return m.getTime() >= U.getTime() ? c + 1 : m.getTime() >= de.getTime() ? c : c - 1;
  }
  e.exports = t.default;
})(bt, bt.exports);
var Ra = bt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(Ra), n = a(ne), o = a(It), s = a(ke), i = Ee;
  function l(d, u) {
    var g, M, b, P, k, p, f, h;
    (0, n.default)(1, arguments);
    var m = (0, i.getDefaultOptions)(), c = (0, s.default)((g = (M = (b = (P = u == null ? void 0 : u.firstWeekContainsDate) !== null && P !== void 0 ? P : u == null || (k = u.locale) === null || k === void 0 || (p = k.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && b !== void 0 ? b : m.firstWeekContainsDate) !== null && M !== void 0 ? M : (f = m.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && g !== void 0 ? g : 1), v = (0, r.default)(d, u), x = /* @__PURE__ */ new Date(0);
    x.setUTCFullYear(v, 0, c), x.setUTCHours(0, 0, 0, 0);
    var S = (0, o.default)(x, u);
    return S;
  }
  e.exports = t.default;
})(yt, yt.exports);
var jn = yt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = l;
  var r = a(ve), n = a(It), o = a(jn), s = a(ne), i = 6048e5;
  function l(d, u) {
    (0, s.default)(1, arguments);
    var g = (0, r.default)(d), M = (0, n.default)(g, u).getTime() - (0, o.default)(g, u).getTime();
    return Math.round(M / i) + 1;
  }
  e.exports = t.default;
})(gt, gt.exports);
var zn = gt.exports, Mt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r, n) {
    for (var o = r < 0 ? "-" : "", s = Math.abs(r).toString(); s.length < n; )
      s = "0" + s;
    return o + s;
  }
  e.exports = t.default;
})(Mt, Mt.exports);
var Aa = Mt.exports, wt = { exports: {} };
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a(Aa), n = {
    // Year
    y: function(i, l) {
      var d = i.getUTCFullYear(), u = d > 0 ? d : 1 - d;
      return (0, r.default)(l === "yy" ? u % 100 : u, l.length);
    },
    // Month
    M: function(i, l) {
      var d = i.getUTCMonth();
      return l === "M" ? String(d + 1) : (0, r.default)(d + 1, 2);
    },
    // Day of the month
    d: function(i, l) {
      return (0, r.default)(i.getUTCDate(), l.length);
    },
    // AM or PM
    a: function(i, l) {
      var d = i.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (l) {
        case "a":
        case "aa":
          return d.toUpperCase();
        case "aaa":
          return d;
        case "aaaaa":
          return d[0];
        case "aaaa":
        default:
          return d === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h: function(i, l) {
      return (0, r.default)(i.getUTCHours() % 12 || 12, l.length);
    },
    // Hour [0-23]
    H: function(i, l) {
      return (0, r.default)(i.getUTCHours(), l.length);
    },
    // Minute
    m: function(i, l) {
      return (0, r.default)(i.getUTCMinutes(), l.length);
    },
    // Second
    s: function(i, l) {
      return (0, r.default)(i.getUTCSeconds(), l.length);
    },
    // Fraction of second
    S: function(i, l) {
      var d = l.length, u = i.getUTCMilliseconds(), g = Math.floor(u * Math.pow(10, d - 3));
      return (0, r.default)(g, l.length);
    }
  }, o = n;
  t.default = o, e.exports = t.default;
})(wt, wt.exports);
var Ln = wt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a($n), n = a(Wn), o = a(La), s = a(zn), i = a(Ra), l = a(Aa), d = a(Ln), u = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, g = {
    // Era
    G: function(f, h, m) {
      var c = f.getUTCFullYear() > 0 ? 1 : 0;
      switch (h) {
        case "G":
        case "GG":
        case "GGG":
          return m.era(c, {
            width: "abbreviated"
          });
        case "GGGGG":
          return m.era(c, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return m.era(c, {
            width: "wide"
          });
      }
    },
    // Year
    y: function(f, h, m) {
      if (h === "yo") {
        var c = f.getUTCFullYear(), v = c > 0 ? c : 1 - c;
        return m.ordinalNumber(v, {
          unit: "year"
        });
      }
      return d.default.y(f, h);
    },
    // Local week-numbering year
    Y: function(f, h, m, c) {
      var v = (0, i.default)(f, c), x = v > 0 ? v : 1 - v;
      if (h === "YY") {
        var S = x % 100;
        return (0, l.default)(S, 2);
      }
      return h === "Yo" ? m.ordinalNumber(x, {
        unit: "year"
      }) : (0, l.default)(x, h.length);
    },
    // ISO week-numbering year
    R: function(f, h) {
      var m = (0, o.default)(f);
      return (0, l.default)(m, h.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(f, h) {
      var m = f.getUTCFullYear();
      return (0, l.default)(m, h.length);
    },
    // Quarter
    Q: function(f, h, m) {
      var c = Math.ceil((f.getUTCMonth() + 1) / 3);
      switch (h) {
        case "Q":
          return String(c);
        case "QQ":
          return (0, l.default)(c, 2);
        case "Qo":
          return m.ordinalNumber(c, {
            unit: "quarter"
          });
        case "QQQ":
          return m.quarter(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return m.quarter(c, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return m.quarter(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(f, h, m) {
      var c = Math.ceil((f.getUTCMonth() + 1) / 3);
      switch (h) {
        case "q":
          return String(c);
        case "qq":
          return (0, l.default)(c, 2);
        case "qo":
          return m.ordinalNumber(c, {
            unit: "quarter"
          });
        case "qqq":
          return m.quarter(c, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return m.quarter(c, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return m.quarter(c, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(f, h, m) {
      var c = f.getUTCMonth();
      switch (h) {
        case "M":
        case "MM":
          return d.default.M(f, h);
        case "Mo":
          return m.ordinalNumber(c + 1, {
            unit: "month"
          });
        case "MMM":
          return m.month(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return m.month(c, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return m.month(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function(f, h, m) {
      var c = f.getUTCMonth();
      switch (h) {
        case "L":
          return String(c + 1);
        case "LL":
          return (0, l.default)(c + 1, 2);
        case "Lo":
          return m.ordinalNumber(c + 1, {
            unit: "month"
          });
        case "LLL":
          return m.month(c, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return m.month(c, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return m.month(c, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function(f, h, m, c) {
      var v = (0, s.default)(f, c);
      return h === "wo" ? m.ordinalNumber(v, {
        unit: "week"
      }) : (0, l.default)(v, h.length);
    },
    // ISO week of year
    I: function(f, h, m) {
      var c = (0, n.default)(f);
      return h === "Io" ? m.ordinalNumber(c, {
        unit: "week"
      }) : (0, l.default)(c, h.length);
    },
    // Day of the month
    d: function(f, h, m) {
      return h === "do" ? m.ordinalNumber(f.getUTCDate(), {
        unit: "date"
      }) : d.default.d(f, h);
    },
    // Day of year
    D: function(f, h, m) {
      var c = (0, r.default)(f);
      return h === "Do" ? m.ordinalNumber(c, {
        unit: "dayOfYear"
      }) : (0, l.default)(c, h.length);
    },
    // Day of week
    E: function(f, h, m) {
      var c = f.getUTCDay();
      switch (h) {
        case "E":
        case "EE":
        case "EEE":
          return m.day(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return m.day(c, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return m.day(c, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return m.day(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(f, h, m, c) {
      var v = f.getUTCDay(), x = (v - c.weekStartsOn + 8) % 7 || 7;
      switch (h) {
        case "e":
          return String(x);
        case "ee":
          return (0, l.default)(x, 2);
        case "eo":
          return m.ordinalNumber(x, {
            unit: "day"
          });
        case "eee":
          return m.day(v, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return m.day(v, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return m.day(v, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return m.day(v, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(f, h, m, c) {
      var v = f.getUTCDay(), x = (v - c.weekStartsOn + 8) % 7 || 7;
      switch (h) {
        case "c":
          return String(x);
        case "cc":
          return (0, l.default)(x, h.length);
        case "co":
          return m.ordinalNumber(x, {
            unit: "day"
          });
        case "ccc":
          return m.day(v, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return m.day(v, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return m.day(v, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return m.day(v, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(f, h, m) {
      var c = f.getUTCDay(), v = c === 0 ? 7 : c;
      switch (h) {
        case "i":
          return String(v);
        case "ii":
          return (0, l.default)(v, h.length);
        case "io":
          return m.ordinalNumber(v, {
            unit: "day"
          });
        case "iii":
          return m.day(c, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return m.day(c, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return m.day(c, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return m.day(c, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(f, h, m) {
      var c = f.getUTCHours(), v = c / 12 >= 1 ? "pm" : "am";
      switch (h) {
        case "a":
        case "aa":
          return m.dayPeriod(v, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return m.dayPeriod(v, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return m.dayPeriod(v, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return m.dayPeriod(v, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(f, h, m) {
      var c = f.getUTCHours(), v;
      switch (c === 12 ? v = u.noon : c === 0 ? v = u.midnight : v = c / 12 >= 1 ? "pm" : "am", h) {
        case "b":
        case "bb":
          return m.dayPeriod(v, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return m.dayPeriod(v, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return m.dayPeriod(v, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return m.dayPeriod(v, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(f, h, m) {
      var c = f.getUTCHours(), v;
      switch (c >= 17 ? v = u.evening : c >= 12 ? v = u.afternoon : c >= 4 ? v = u.morning : v = u.night, h) {
        case "B":
        case "BB":
        case "BBB":
          return m.dayPeriod(v, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return m.dayPeriod(v, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return m.dayPeriod(v, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(f, h, m) {
      if (h === "ho") {
        var c = f.getUTCHours() % 12;
        return c === 0 && (c = 12), m.ordinalNumber(c, {
          unit: "hour"
        });
      }
      return d.default.h(f, h);
    },
    // Hour [0-23]
    H: function(f, h, m) {
      return h === "Ho" ? m.ordinalNumber(f.getUTCHours(), {
        unit: "hour"
      }) : d.default.H(f, h);
    },
    // Hour [0-11]
    K: function(f, h, m) {
      var c = f.getUTCHours() % 12;
      return h === "Ko" ? m.ordinalNumber(c, {
        unit: "hour"
      }) : (0, l.default)(c, h.length);
    },
    // Hour [1-24]
    k: function(f, h, m) {
      var c = f.getUTCHours();
      return c === 0 && (c = 24), h === "ko" ? m.ordinalNumber(c, {
        unit: "hour"
      }) : (0, l.default)(c, h.length);
    },
    // Minute
    m: function(f, h, m) {
      return h === "mo" ? m.ordinalNumber(f.getUTCMinutes(), {
        unit: "minute"
      }) : d.default.m(f, h);
    },
    // Second
    s: function(f, h, m) {
      return h === "so" ? m.ordinalNumber(f.getUTCSeconds(), {
        unit: "second"
      }) : d.default.s(f, h);
    },
    // Fraction of second
    S: function(f, h) {
      return d.default.S(f, h);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(f, h, m, c) {
      var v = c._originalDate || f, x = v.getTimezoneOffset();
      if (x === 0)
        return "Z";
      switch (h) {
        case "X":
          return b(x);
        case "XXXX":
        case "XX":
          return P(x);
        case "XXXXX":
        case "XXX":
        default:
          return P(x, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(f, h, m, c) {
      var v = c._originalDate || f, x = v.getTimezoneOffset();
      switch (h) {
        case "x":
          return b(x);
        case "xxxx":
        case "xx":
          return P(x);
        case "xxxxx":
        case "xxx":
        default:
          return P(x, ":");
      }
    },
    // Timezone (GMT)
    O: function(f, h, m, c) {
      var v = c._originalDate || f, x = v.getTimezoneOffset();
      switch (h) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + M(x, ":");
        case "OOOO":
        default:
          return "GMT" + P(x, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(f, h, m, c) {
      var v = c._originalDate || f, x = v.getTimezoneOffset();
      switch (h) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + M(x, ":");
        case "zzzz":
        default:
          return "GMT" + P(x, ":");
      }
    },
    // Seconds timestamp
    t: function(f, h, m, c) {
      var v = c._originalDate || f, x = Math.floor(v.getTime() / 1e3);
      return (0, l.default)(x, h.length);
    },
    // Milliseconds timestamp
    T: function(f, h, m, c) {
      var v = c._originalDate || f, x = v.getTime();
      return (0, l.default)(x, h.length);
    }
  };
  function M(p, f) {
    var h = p > 0 ? "-" : "+", m = Math.abs(p), c = Math.floor(m / 60), v = m % 60;
    if (v === 0)
      return h + String(c);
    var x = f || "";
    return h + String(c) + x + (0, l.default)(v, 2);
  }
  function b(p, f) {
    if (p % 60 === 0) {
      var h = p > 0 ? "-" : "+";
      return h + (0, l.default)(Math.abs(p) / 60, 2);
    }
    return P(p, f);
  }
  function P(p, f) {
    var h = f || "", m = p > 0 ? "-" : "+", c = Math.abs(p), v = (0, l.default)(Math.floor(c / 60), 2), x = (0, l.default)(c % 60, 2);
    return m + v + h + x;
  }
  var k = g;
  t.default = k, e.exports = t.default;
})(ut, ut.exports);
var Hn = ut.exports, Pt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = function(l, d) {
    switch (l) {
      case "P":
        return d.date({
          width: "short"
        });
      case "PP":
        return d.date({
          width: "medium"
        });
      case "PPP":
        return d.date({
          width: "long"
        });
      case "PPPP":
      default:
        return d.date({
          width: "full"
        });
    }
  }, r = function(l, d) {
    switch (l) {
      case "p":
        return d.time({
          width: "short"
        });
      case "pp":
        return d.time({
          width: "medium"
        });
      case "ppp":
        return d.time({
          width: "long"
        });
      case "pppp":
      default:
        return d.time({
          width: "full"
        });
    }
  }, n = function(l, d) {
    var u = l.match(/(P+)(p+)?/) || [], g = u[1], M = u[2];
    if (!M)
      return a(l, d);
    var b;
    switch (g) {
      case "P":
        b = d.dateTime({
          width: "short"
        });
        break;
      case "PP":
        b = d.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        b = d.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        b = d.dateTime({
          width: "full"
        });
        break;
    }
    return b.replace("{{date}}", a(g, d)).replace("{{time}}", r(M, d));
  }, o = {
    p: r,
    P: n
  }, s = o;
  t.default = s, e.exports = t.default;
})(Pt, Pt.exports);
var Rn = Pt.exports, xt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r) {
    var n = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return n.setUTCFullYear(r.getFullYear()), r.getTime() - n.getTime();
  }
  e.exports = t.default;
})(xt, xt.exports);
var Fa = xt.exports;
const Zt = /* @__PURE__ */ Ye(Fa);
var ze = {};
Object.defineProperty(ze, "__esModule", {
  value: !0
});
ze.isProtectedDayOfYearToken = In;
ze.isProtectedWeekYearToken = Yn;
ze.throwProtectedError = qn;
var An = ["D", "DD"], Fn = ["YY", "YYYY"];
function In(e) {
  return An.indexOf(e) !== -1;
}
function Yn(e) {
  return Fn.indexOf(e) !== -1;
}
function qn(e, t, a) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Ct = { exports: {} }, _t = { exports: {} }, kt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, r = function(s, i, l) {
    var d, u = a[s];
    return typeof u == "string" ? d = u : i === 1 ? d = u.one : d = u.other.replace("{{count}}", i.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + d : d + " ago" : d;
  }, n = r;
  t.default = n, e.exports = t.default;
})(kt, kt.exports);
var Un = kt.exports, Et = { exports: {} }, Dt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r) {
    return function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = n.width ? String(n.width) : r.defaultWidth, s = r.formats[o] || r.formats[r.defaultWidth];
      return s;
    };
  }
  e.exports = t.default;
})(Dt, Dt.exports);
var Bn = Dt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a(Bn), n = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, o = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, s = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, i = {
    date: (0, r.default)({
      formats: n,
      defaultWidth: "full"
    }),
    time: (0, r.default)({
      formats: o,
      defaultWidth: "full"
    }),
    dateTime: (0, r.default)({
      formats: s,
      defaultWidth: "full"
    })
  }, l = i;
  t.default = l, e.exports = t.default;
})(Et, Et.exports);
var Xn = Et.exports, Tt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, r = function(s, i, l, d) {
    return a[s];
  }, n = r;
  t.default = n, e.exports = t.default;
})(Tt, Tt.exports);
var Vn = Tt.exports, $t = { exports: {} }, St = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r) {
    return function(n, o) {
      var s = o != null && o.context ? String(o.context) : "standalone", i;
      if (s === "formatting" && r.formattingValues) {
        var l = r.defaultFormattingWidth || r.defaultWidth, d = o != null && o.width ? String(o.width) : l;
        i = r.formattingValues[d] || r.formattingValues[l];
      } else {
        var u = r.defaultWidth, g = o != null && o.width ? String(o.width) : r.defaultWidth;
        i = r.values[g] || r.values[u];
      }
      var M = r.argumentCallback ? r.argumentCallback(n) : n;
      return i[M];
    };
  }
  e.exports = t.default;
})(St, St.exports);
var Jn = St.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a(Jn), n = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, o = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, s = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  }, i = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  }, l = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, d = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, u = function(P, k) {
    var p = Number(P), f = p % 100;
    if (f > 20 || f < 10)
      switch (f % 10) {
        case 1:
          return p + "st";
        case 2:
          return p + "nd";
        case 3:
          return p + "rd";
      }
    return p + "th";
  }, g = {
    ordinalNumber: u,
    era: (0, r.default)({
      values: n,
      defaultWidth: "wide"
    }),
    quarter: (0, r.default)({
      values: o,
      defaultWidth: "wide",
      argumentCallback: function(P) {
        return P - 1;
      }
    }),
    month: (0, r.default)({
      values: s,
      defaultWidth: "wide"
    }),
    day: (0, r.default)({
      values: i,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, r.default)({
      values: l,
      defaultWidth: "wide",
      formattingValues: d,
      defaultFormattingWidth: "wide"
    })
  }, M = g;
  t.default = M, e.exports = t.default;
})($t, $t.exports);
var Qn = $t.exports, Wt = { exports: {} }, Nt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(o) {
    return function(s) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = i.width, d = l && o.matchPatterns[l] || o.matchPatterns[o.defaultMatchWidth], u = s.match(d);
      if (!u)
        return null;
      var g = u[0], M = l && o.parsePatterns[l] || o.parsePatterns[o.defaultParseWidth], b = Array.isArray(M) ? n(M, function(p) {
        return p.test(g);
      }) : r(M, function(p) {
        return p.test(g);
      }), P;
      P = o.valueCallback ? o.valueCallback(b) : b, P = i.valueCallback ? i.valueCallback(P) : P;
      var k = s.slice(g.length);
      return {
        value: P,
        rest: k
      };
    };
  }
  function r(o, s) {
    for (var i in o)
      if (o.hasOwnProperty(i) && s(o[i]))
        return i;
  }
  function n(o, s) {
    for (var i = 0; i < o.length; i++)
      if (s(o[i]))
        return i;
  }
  e.exports = t.default;
})(Nt, Nt.exports);
var Kn = Nt.exports, Ot = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r) {
    return function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.match(r.matchPattern);
      if (!s)
        return null;
      var i = s[0], l = n.match(r.parsePattern);
      if (!l)
        return null;
      var d = r.valueCallback ? r.valueCallback(l[0]) : l[0];
      d = o.valueCallback ? o.valueCallback(d) : d;
      var u = n.slice(i.length);
      return {
        value: d,
        rest: u
      };
    };
  }
  e.exports = t.default;
})(Ot, Ot.exports);
var Zn = Ot.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a(Kn), n = a(Zn), o = /^(\d+)(th|st|nd|rd)?/i, s = /\d+/i, i = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, l = {
    any: [/^b/i, /^(a|c)/i]
  }, d = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, u = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, g = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, M = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  }, b = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, P = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, k = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, p = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, f = {
    ordinalNumber: (0, n.default)({
      matchPattern: o,
      parsePattern: s,
      valueCallback: function(c) {
        return parseInt(c, 10);
      }
    }),
    era: (0, r.default)({
      matchPatterns: i,
      defaultMatchWidth: "wide",
      parsePatterns: l,
      defaultParseWidth: "any"
    }),
    quarter: (0, r.default)({
      matchPatterns: d,
      defaultMatchWidth: "wide",
      parsePatterns: u,
      defaultParseWidth: "any",
      valueCallback: function(c) {
        return c + 1;
      }
    }),
    month: (0, r.default)({
      matchPatterns: g,
      defaultMatchWidth: "wide",
      parsePatterns: M,
      defaultParseWidth: "any"
    }),
    day: (0, r.default)({
      matchPatterns: b,
      defaultMatchWidth: "wide",
      parsePatterns: P,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, r.default)({
      matchPatterns: k,
      defaultMatchWidth: "any",
      parsePatterns: p,
      defaultParseWidth: "any"
    })
  }, h = f;
  t.default = h, e.exports = t.default;
})(Wt, Wt.exports);
var Gn = Wt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a(Un), n = a(Xn), o = a(Vn), s = a(Qn), i = a(Gn), l = {
    code: "en-US",
    formatDistance: r.default,
    formatLong: n.default,
    formatRelative: o.default,
    localize: s.default,
    match: i.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  }, d = l;
  t.default = d, e.exports = t.default;
})(_t, _t.exports);
var eo = _t.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = a(eo), n = r.default;
  t.default = n, e.exports = t.default;
})(Ct, Ct.exports);
var to = Ct.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = m;
  var r = a(kn), n = a(Tn), o = a(ve), s = a(Hn), i = a(Rn), l = a(Fa), d = ze, u = a(ke), g = a(ne), M = Ee, b = a(to), P = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, k = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, p = /^'([^]*?)'?$/, f = /''/g, h = /[a-zA-Z]/;
  function m(v, x, S) {
    var U, R, de, Ce, E, C, O, j, ee, V, J, _, y, L, D, N, z, F;
    (0, g.default)(2, arguments);
    var Q = String(x), Z = (0, M.getDefaultOptions)(), le = (U = (R = S == null ? void 0 : S.locale) !== null && R !== void 0 ? R : Z.locale) !== null && U !== void 0 ? U : b.default, pe = (0, u.default)((de = (Ce = (E = (C = S == null ? void 0 : S.firstWeekContainsDate) !== null && C !== void 0 ? C : S == null || (O = S.locale) === null || O === void 0 || (j = O.options) === null || j === void 0 ? void 0 : j.firstWeekContainsDate) !== null && E !== void 0 ? E : Z.firstWeekContainsDate) !== null && Ce !== void 0 ? Ce : (ee = Z.locale) === null || ee === void 0 || (V = ee.options) === null || V === void 0 ? void 0 : V.firstWeekContainsDate) !== null && de !== void 0 ? de : 1);
    if (!(pe >= 1 && pe <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var ue = (0, u.default)((J = (_ = (y = (L = S == null ? void 0 : S.weekStartsOn) !== null && L !== void 0 ? L : S == null || (D = S.locale) === null || D === void 0 || (N = D.options) === null || N === void 0 ? void 0 : N.weekStartsOn) !== null && y !== void 0 ? y : Z.weekStartsOn) !== null && _ !== void 0 ? _ : (z = Z.locale) === null || z === void 0 || (F = z.options) === null || F === void 0 ? void 0 : F.weekStartsOn) !== null && J !== void 0 ? J : 0);
    if (!(ue >= 0 && ue <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!le.localize)
      throw new RangeError("locale must contain localize property");
    if (!le.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var K = (0, o.default)(v);
    if (!(0, r.default)(K))
      throw new RangeError("Invalid time value");
    var ce = (0, l.default)(K), fe = (0, n.default)(K, ce), he = {
      firstWeekContainsDate: pe,
      weekStartsOn: ue,
      locale: le,
      _originalDate: K
    }, Y = Q.match(k).map(function(A) {
      var B = A[0];
      if (B === "p" || B === "P") {
        var I = i.default[B];
        return I(A, le.formatLong);
      }
      return A;
    }).join("").match(P).map(function(A) {
      if (A === "''")
        return "'";
      var B = A[0];
      if (B === "'")
        return c(A);
      var I = s.default[B];
      if (I)
        return !(S != null && S.useAdditionalWeekYearTokens) && (0, d.isProtectedWeekYearToken)(A) && (0, d.throwProtectedError)(A, x, String(v)), !(S != null && S.useAdditionalDayOfYearTokens) && (0, d.isProtectedDayOfYearToken)(A) && (0, d.throwProtectedError)(A, x, String(v)), I(fe, A, le.localize, he);
      if (B.match(h))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + B + "`");
      return A;
    }).join("");
    return Y;
  }
  function c(v) {
    var x = v.match(p);
    return x ? x[1].replace(f, "'") : v;
  }
  e.exports = t.default;
})(at, at.exports);
var ao = at.exports;
const ro = /* @__PURE__ */ Ye(ao);
function Gt(e, t, a) {
  var r = io(e, a.timeZone, a.locale);
  return r.formatToParts ? no(r, t) : oo(r, t);
}
function no(e, t) {
  for (var a = e.formatToParts(t), r = a.length - 1; r >= 0; --r)
    if (a[r].type === "timeZoneName")
      return a[r].value;
}
function oo(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(a);
  return r ? r[0].substr(1) : "";
}
function io(e, t, a) {
  if (a && !a.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(a ? [a.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function so(e, t) {
  var a = co(t);
  return a.formatToParts ? uo(a, e) : mo(a, e);
}
var lo = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function uo(e, t) {
  try {
    for (var a = e.formatToParts(t), r = [], n = 0; n < a.length; n++) {
      var o = lo[a[n].type];
      o >= 0 && (r[o] = parseInt(a[n].value, 10));
    }
    return r;
  } catch (s) {
    if (s instanceof RangeError)
      return [NaN];
    throw s;
  }
}
function mo(e, t) {
  var a = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var Be = {};
function co(e) {
  if (!Be[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Be[e] = a ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Be[e];
}
function Ia(e, t, a, r, n, o, s) {
  var i = /* @__PURE__ */ new Date(0);
  return i.setUTCFullYear(e, t, a), i.setUTCHours(r, n, o, s), i;
}
var ea = 36e5, fo = 6e4, Xe = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Yt(e, t, a) {
  var r, n;
  if (!e || (r = Xe.timezoneZ.exec(e), r))
    return 0;
  var o;
  if (r = Xe.timezoneHH.exec(e), r)
    return o = parseInt(r[1], 10), ta(o) ? -(o * ea) : NaN;
  if (r = Xe.timezoneHHMM.exec(e), r) {
    o = parseInt(r[2], 10);
    var s = parseInt(r[3], 10);
    return ta(o, s) ? (n = Math.abs(o) * ea + s * fo, r[1] === "+" ? -n : n) : NaN;
  }
  if (go(e)) {
    t = new Date(t || Date.now());
    var i = a ? t : ho(t), l = jt(i, e), d = a ? l : vo(t, l, e);
    return -d;
  }
  return NaN;
}
function ho(e) {
  return Ia(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function jt(e, t) {
  var a = so(e, t), r = Ia(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), n = e.getTime(), o = n % 1e3;
  return n -= o >= 0 ? o : 1e3 + o, r - n;
}
function vo(e, t, a) {
  var r = e.getTime(), n = r - t, o = jt(new Date(n), a);
  if (t === o)
    return t;
  n -= o - t;
  var s = jt(new Date(n), a);
  return o === s ? o : Math.max(o, s);
}
function ta(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var aa = {};
function go(e) {
  if (aa[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), aa[e] = !0, !0;
  } catch {
    return !1;
  }
}
var po = 60 * 1e3, yo = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, a, r) {
    var n = Ve(r.timeZone, e);
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return ra(n);
      case "XXXX":
      case "XX":
        return We(n);
      case "XXXXX":
      case "XXX":
      default:
        return We(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, a, r) {
    var n = Ve(r.timeZone, e);
    switch (t) {
      case "x":
        return ra(n);
      case "xxxx":
      case "xx":
        return We(n);
      case "xxxxx":
      case "xxx":
      default:
        return We(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, a, r) {
    var n = Ve(r.timeZone, e);
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + bo(n, ":");
      case "OOOO":
      default:
        return "GMT" + We(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, a, r) {
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return Gt("short", e, r);
      case "zzzz":
      default:
        return Gt("long", e, r);
    }
  }
};
function Ve(e, t) {
  var a = e ? Yt(e, t, !0) / po : t.getTimezoneOffset();
  if (Number.isNaN(a))
    throw new RangeError("Invalid time zone specified: " + e);
  return a;
}
function Fe(e, t) {
  for (var a = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return a + r;
}
function We(e, t) {
  var a = t || "", r = e > 0 ? "-" : "+", n = Math.abs(e), o = Fe(Math.floor(n / 60), 2), s = Fe(Math.floor(n % 60), 2);
  return r + o + a + s;
}
function ra(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + Fe(Math.abs(e) / 60, 2);
  }
  return We(e, t);
}
function bo(e, t) {
  var a = e > 0 ? "-" : "+", r = Math.abs(e), n = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return a + String(n);
  var s = t || "";
  return a + String(n) + s + Fe(o, 2);
}
const Mo = yo;
var wo = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Je = 36e5, na = 6e4, Po = 2, ae = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: wo
};
function Ya(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, r = a.additionalDigits == null ? Po : En(a.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = xo(e), o = Co(n.date, r), s = o.year, i = o.restDateString, l = _o(i, s);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var d = l.getTime(), u = 0, g;
    if (n.time && (u = ko(n.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || a.timeZone) {
      if (g = Yt(n.timeZone || a.timeZone, new Date(d + u)), isNaN(g))
        return /* @__PURE__ */ new Date(NaN);
    } else
      g = Zt(new Date(d + u)), g = Zt(new Date(d + u + g));
    return new Date(d + u + g);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function xo(e) {
  var t = {}, a = ae.dateTimePattern.exec(e), r;
  if (a ? (t.date = a[1], r = a[3]) : (a = ae.datePattern.exec(e), a ? (t.date = a[1], r = a[2]) : (t.date = null, r = e)), r) {
    var n = ae.timeZone.exec(r);
    n ? (t.time = r.replace(n[1], ""), t.timeZone = n[1].trim()) : t.time = r;
  }
  return t;
}
function Co(e, t) {
  var a = ae.YYY[t], r = ae.YYYYY[t], n;
  if (n = ae.YYYY.exec(e) || r.exec(e), n) {
    var o = n[1];
    return {
      year: parseInt(o, 10),
      restDateString: e.slice(o.length)
    };
  }
  if (n = ae.YY.exec(e) || a.exec(e), n) {
    var s = n[1];
    return {
      year: parseInt(s, 10) * 100,
      restDateString: e.slice(s.length)
    };
  }
  return {
    year: null
  };
}
function _o(e, t) {
  if (t === null)
    return null;
  var a, r, n, o;
  if (e.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  if (a = ae.MM.exec(e), a)
    return r = /* @__PURE__ */ new Date(0), n = parseInt(a[1], 10) - 1, ia(t, n) ? (r.setUTCFullYear(t, n), r) : /* @__PURE__ */ new Date(NaN);
  if (a = ae.DDD.exec(e), a) {
    r = /* @__PURE__ */ new Date(0);
    var s = parseInt(a[1], 10);
    return To(t, s) ? (r.setUTCFullYear(t, 0, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = ae.MMDD.exec(e), a) {
    r = /* @__PURE__ */ new Date(0), n = parseInt(a[1], 10) - 1;
    var i = parseInt(a[2], 10);
    return ia(t, n, i) ? (r.setUTCFullYear(t, n, i), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = ae.Www.exec(e), a)
    return o = parseInt(a[1], 10) - 1, sa(t, o) ? oa(t, o) : /* @__PURE__ */ new Date(NaN);
  if (a = ae.WwwD.exec(e), a) {
    o = parseInt(a[1], 10) - 1;
    var l = parseInt(a[2], 10) - 1;
    return sa(t, o, l) ? oa(t, o, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function ko(e) {
  var t, a, r;
  if (t = ae.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), Qe(a) ? a % 24 * Je : NaN;
  if (t = ae.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), Qe(a, r) ? a % 24 * Je + r * na : NaN;
  if (t = ae.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), r = parseInt(t[2], 10);
    var n = parseFloat(t[3].replace(",", "."));
    return Qe(a, r, n) ? a % 24 * Je + r * na + n * 1e3 : NaN;
  }
  return null;
}
function oa(e, t, a) {
  t = t || 0, a = a || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var n = r.getUTCDay() || 7, o = t * 7 + a + 1 - n;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
var Eo = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Do = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function qa(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ia(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var r = qa(e);
    if (r && a > Do[t] || !r && a > Eo[t])
      return !1;
  }
  return !0;
}
function To(e, t) {
  if (t < 1)
    return !1;
  var a = qa(e);
  return !(a && t > 366 || !a && t > 365);
}
function sa(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function Qe(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
var $o = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function So(e, t, a) {
  var r = String(t), n = a || {}, o = r.match($o);
  if (o) {
    var s = Ya(n.originalDate || e, n);
    r = o.reduce(function(i, l) {
      if (l[0] === "'")
        return i;
      var d = i.indexOf(l), u = i[d - 1] === "'", g = i.replace(
        l,
        "'" + Mo[l[0]](s, l, null, n) + "'"
      );
      return u ? g.substring(0, d - 1) + g.substring(d + 1) : g;
    }, r);
  }
  return ro(e, r, n);
}
var zt = { exports: {} }, Lt = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(r, n) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
    return r;
  }
  e.exports = t.default;
})(Lt, Lt.exports);
var Wo = Lt.exports;
(function(e, t) {
  var a = q.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  var r = a(Wo);
  function n(o) {
    return (0, r.default)({}, o);
  }
  e.exports = t.default;
})(zt, zt.exports);
var No = zt.exports;
const Oo = /* @__PURE__ */ Ye(No);
function jo(e, t, a) {
  var r = Ya(e, a), n = Yt(t, r, !0), o = new Date(r.getTime() - n), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), s.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), s;
}
function zo(e, t, a, r) {
  var n = Oo(r);
  return n.timeZone = t, n.originalDate = e, So(jo(e, t), a, n);
}
function W(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width ? String(t.width) : e.defaultWidth, r = e.formats[a] || e.formats[e.defaultWidth];
    return r;
  };
}
function T(e) {
  return function(t, a) {
    var r = a != null && a.context ? String(a.context) : "standalone", n;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, s = a != null && a.width ? String(a.width) : o;
      n = e.formattingValues[s] || e.formattingValues[o];
    } else {
      var i = e.defaultWidth, l = a != null && a.width ? String(a.width) : e.defaultWidth;
      n = e.values[l] || e.values[i];
    }
    var d = e.argumentCallback ? e.argumentCallback(t) : t;
    return n[d];
  };
}
function $(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = a.width, n = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(n);
    if (!o)
      return null;
    var s = o[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(i) ? Ho(i, function(g) {
      return g.test(s);
    }) : Lo(i, function(g) {
      return g.test(s);
    }), d;
    d = e.valueCallback ? e.valueCallback(l) : l, d = a.valueCallback ? a.valueCallback(d) : d;
    var u = t.slice(s.length);
    return {
      value: d,
      rest: u
    };
  };
}
function Lo(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a) && t(e[a]))
      return a;
}
function Ho(e, t) {
  for (var a = 0; a < e.length; a++)
    if (t(e[a]))
      return a;
}
function ge(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var n = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var s = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    s = a.valueCallback ? a.valueCallback(s) : s;
    var i = t.slice(n.length);
    return {
      value: s,
      rest: i
    };
  };
}
function Ht(e) {
  "@babel/helpers - typeof";
  return Ht = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ht(e);
}
function Ro(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function qt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Ao(e) {
  qt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Ht(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
var Fo = {};
function Io() {
  return Fo;
}
function la(e, t) {
  var a, r, n, o, s, i, l, d;
  qt(1, arguments);
  var u = Io(), g = Ro((a = (r = (n = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (s = t.locale) === null || s === void 0 || (i = s.options) === null || i === void 0 ? void 0 : i.weekStartsOn) !== null && n !== void 0 ? n : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(g >= 0 && g <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var M = Ao(e), b = M.getUTCDay(), P = (b < g ? 7 : 0) + b - g;
  return M.setUTCDate(M.getUTCDate() - P), M.setUTCHours(0, 0, 0, 0), M;
}
var Yo = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qo = function(t, a, r) {
  var n, o = Yo[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", a.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
const Oe = qo;
var Uo = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Bo = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Xo = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Vo = {
  date: W({
    formats: Uo,
    defaultWidth: "full"
  }),
  time: W({
    formats: Bo,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Xo,
    defaultWidth: "full"
  })
};
const Jo = Vo;
var Qo = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ko = function(t, a, r, n) {
  return Qo[t];
};
const De = Ko;
var Zo = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Go = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ei = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, ti = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, ai = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ri = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ni = function(t, a) {
  var r = Number(t), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, oi = {
  ordinalNumber: ni,
  era: T({
    values: Zo,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: Go,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: ei,
    defaultWidth: "wide"
  }),
  day: T({
    values: ti,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: ai,
    defaultWidth: "wide",
    formattingValues: ri,
    defaultFormattingWidth: "wide"
  })
};
const Te = oi;
var ii = /^(\d+)(th|st|nd|rd)?/i, si = /\d+/i, li = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, di = {
  any: [/^b/i, /^(a|c)/i]
}, ui = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, mi = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ci = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, fi = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, hi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, vi = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gi = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, pi = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yi = {
  ordinalNumber: ge({
    matchPattern: ii,
    parsePattern: si,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: li,
    defaultMatchWidth: "wide",
    parsePatterns: di,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: ui,
    defaultMatchWidth: "wide",
    parsePatterns: mi,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: ci,
    defaultMatchWidth: "wide",
    parsePatterns: fi,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: hi,
    defaultMatchWidth: "wide",
    parsePatterns: vi,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: gi,
    defaultMatchWidth: "any",
    parsePatterns: pi,
    defaultParseWidth: "any"
  })
};
const $e = yi;
var bi = {
  code: "en-US",
  formatDistance: Oe,
  formatLong: Jo,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const da = bi;
function ua(e, t, a) {
  qt(2, arguments);
  var r = la(e, a), n = la(t, a);
  return r.getTime() === n.getTime();
}
var Mi = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, wi = function(t, a, r) {
  var n, o = Mi[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " siden" : n;
};
const Pi = wi;
var xi = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, Ci = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, _i = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ki = {
  date: W({
    formats: xi,
    defaultWidth: "full"
  }),
  time: W({
    formats: Ci,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: _i,
    defaultWidth: "full"
  })
};
const Ei = ki;
var Di = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, Ti = function(t, a, r, n) {
  return Di[t];
};
const $i = Ti;
var Si = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Wi = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Ni = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, Oi = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, ji = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, zi = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, Li = function(t, a) {
  var r = Number(t);
  return r + ".";
}, Hi = {
  ordinalNumber: Li,
  era: T({
    values: Si,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: Wi,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: Ni,
    defaultWidth: "wide"
  }),
  day: T({
    values: Oi,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: ji,
    defaultWidth: "wide",
    formattingValues: zi,
    defaultFormattingWidth: "wide"
  })
};
const Ri = Hi;
var Ai = /^(\d+)(\.)?/i, Fi = /\d+/i, Ii = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Yi = {
  any: [/^f/i, /^(v|e)/i]
}, qi = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Ui = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bi = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, Xi = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Vi = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Ji = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Qi = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, Ki = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, Zi = {
  ordinalNumber: ge({
    matchPattern: Ai,
    parsePattern: Fi,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: Ii,
    defaultMatchWidth: "wide",
    parsePatterns: Yi,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: qi,
    defaultMatchWidth: "wide",
    parsePatterns: Ui,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Bi,
    defaultMatchWidth: "wide",
    parsePatterns: Xi,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: Vi,
    defaultMatchWidth: "wide",
    parsePatterns: Ji,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: Qi,
    defaultMatchWidth: "any",
    parsePatterns: Ki,
    defaultParseWidth: "any"
  })
};
const Gi = Zi;
var es = {
  code: "da",
  formatDistance: Pi,
  formatLong: Ei,
  formatRelative: $i,
  localize: Ri,
  match: Gi,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const ts = es;
var ma = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, as = function(t, a, r) {
  var n, o = r != null && r.addSuffix ? ma[t].withPreposition : ma[t].standalone;
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : "vor " + n : n;
};
const rs = as;
var ns = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, os = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, is = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ss = {
  date: W({
    formats: ns,
    defaultWidth: "full"
  }),
  time: W({
    formats: os,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: is,
    defaultWidth: "full"
  })
};
const ls = ss;
var ds = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, us = function(t, a, r, n) {
  return ds[t];
};
const ms = us;
var cs = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, fs = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, Rt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, hs = {
  narrow: Rt.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: Rt.wide
}, vs = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, gs = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, ps = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, ys = function(t) {
  var a = Number(t);
  return a + ".";
}, bs = {
  ordinalNumber: ys,
  era: T({
    values: cs,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: fs,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: Rt,
    formattingValues: hs,
    defaultWidth: "wide"
  }),
  day: T({
    values: vs,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: gs,
    defaultWidth: "wide",
    formattingValues: ps,
    defaultFormattingWidth: "wide"
  })
};
const Ms = bs;
var ws = /^(\d+)(\.)?/i, Ps = /\d+/i, xs = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, Cs = {
  any: [/^v/i, /^n/i]
}, _s = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, ks = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Es = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, Ds = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Ts = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, $s = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Ss = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Ws = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, Ns = {
  ordinalNumber: ge({
    matchPattern: ws,
    parsePattern: Ps,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: $({
    matchPatterns: xs,
    defaultMatchWidth: "wide",
    parsePatterns: Cs,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: _s,
    defaultMatchWidth: "wide",
    parsePatterns: ks,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Es,
    defaultMatchWidth: "wide",
    parsePatterns: Ds,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: Ts,
    defaultMatchWidth: "wide",
    parsePatterns: $s,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: Ss,
    defaultMatchWidth: "wide",
    parsePatterns: Ws,
    defaultParseWidth: "any"
  })
};
const Os = Ns;
var js = {
  code: "de",
  formatDistance: rs,
  formatLong: ls,
  formatRelative: ms,
  localize: Ms,
  match: Os,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const zs = js;
var Ls = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Hs = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Rs = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, As = {
  date: W({
    formats: Ls,
    defaultWidth: "full"
  }),
  time: W({
    formats: Hs,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Rs,
    defaultWidth: "full"
  })
};
const Fs = As;
var Is = {
  code: "en-AU",
  formatDistance: Oe,
  formatLong: Fs,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const ca = Is;
var Ys = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, qs = function(t, a, r) {
  var n, o = Ys[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", a.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
const Us = qs;
var Bs = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, Xs = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Vs = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Js = {
  date: W({
    formats: Bs,
    defaultWidth: "full"
  }),
  time: W({
    formats: Xs,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Vs,
    defaultWidth: "full"
  })
};
const Qs = Js;
var Ks = {
  code: "en-CA",
  formatDistance: Us,
  formatLong: Qs,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Zs = Ks;
var Gs = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, el = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, tl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, al = {
  date: W({
    formats: Gs,
    defaultWidth: "full"
  }),
  time: W({
    formats: el,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: tl,
    defaultWidth: "full"
  })
};
const rl = al;
var nl = {
  code: "en-GB",
  formatDistance: Oe,
  formatLong: rl,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ae = nl;
var ol = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, il = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, sl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ll = {
  date: W({
    formats: ol,
    defaultWidth: "full"
  }),
  time: W({
    formats: il,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: sl,
    defaultWidth: "full"
  })
};
const dl = ll;
var ul = {
  code: "en-IN",
  formatDistance: Oe,
  formatLong: dl,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
};
const ml = ul;
var cl = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, fl = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vl = {
  date: W({
    formats: cl,
    defaultWidth: "full"
  }),
  time: W({
    formats: fl,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: hl,
    defaultWidth: "full"
  })
};
const gl = vl;
var pl = {
  code: "en-NZ",
  formatDistance: Oe,
  formatLong: gl,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const yl = pl;
var bl = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, Ml = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, wl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Pl = {
  date: W({
    formats: bl,
    defaultWidth: "full"
  }),
  time: W({
    formats: Ml,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: wl,
    defaultWidth: "full"
  })
};
const xl = Pl;
var Cl = {
  code: "en-ZA",
  formatDistance: Oe,
  formatLong: xl,
  formatRelative: De,
  localize: Te,
  match: $e,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
};
const _l = Cl;
var kl = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, El = function(t, a, r) {
  var n, o = kl[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", a.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + n : "hace " + n : n;
};
const Dl = El;
var Tl = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, $l = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Sl = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Wl = {
  date: W({
    formats: Tl,
    defaultWidth: "full"
  }),
  time: W({
    formats: $l,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Sl,
    defaultWidth: "full"
  })
};
const Nl = Wl;
var Ol = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, jl = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, zl = function(t, a, r, n) {
  return a.getUTCHours() !== 1 ? jl[t] : Ol[t];
};
const Ll = zl;
var Hl = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, Rl = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Al = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
}, Fl = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
}, Il = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Yl = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, ql = function(t, a) {
  var r = Number(t);
  return r + "º";
}, Ul = {
  ordinalNumber: ql,
  era: T({
    values: Hl,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: Rl,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: T({
    values: Al,
    defaultWidth: "wide"
  }),
  day: T({
    values: Fl,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: Il,
    defaultWidth: "wide",
    formattingValues: Yl,
    defaultFormattingWidth: "wide"
  })
};
const Bl = Ul;
var Xl = /^(\d+)(º)?/i, Vl = /\d+/i, Jl = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Ql = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
}, Kl = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Zl = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Gl = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, ed = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
}, td = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, ad = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, rd = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, nd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, od = {
  ordinalNumber: ge({
    matchPattern: Xl,
    parsePattern: Vl,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: Jl,
    defaultMatchWidth: "wide",
    parsePatterns: Ql,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: Kl,
    defaultMatchWidth: "wide",
    parsePatterns: Zl,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Gl,
    defaultMatchWidth: "wide",
    parsePatterns: ed,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: td,
    defaultMatchWidth: "wide",
    parsePatterns: ad,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: rd,
    defaultMatchWidth: "any",
    parsePatterns: nd,
    defaultParseWidth: "any"
  })
};
const id = od;
var sd = {
  code: "es",
  formatDistance: Dl,
  formatLong: Nl,
  formatRelative: Ll,
  localize: Bl,
  match: id,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const fa = sd;
var ld = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, dd = function(t, a, r) {
  var n, o = ld[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + n : "il y a " + n : n;
};
const ud = dd;
var md = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, cd = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, fd = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hd = {
  date: W({
    formats: md,
    defaultWidth: "full"
  }),
  time: W({
    formats: cd,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: fd,
    defaultWidth: "full"
  })
};
const vd = hd;
var gd = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, pd = function(t, a, r, n) {
  return gd[t];
};
const yd = pd;
var bd = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, Md = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, wd = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, Pd = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, xd = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, Cd = function(t, a) {
  var r = Number(t), n = a == null ? void 0 : a.unit;
  if (r === 0)
    return "0";
  var o = ["year", "week", "hour", "minute", "second"], s;
  return r === 1 ? s = n && o.includes(n) ? "ère" : "er" : s = "ème", r + s;
}, _d = {
  ordinalNumber: Cd,
  era: T({
    values: bd,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: Md,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: wd,
    defaultWidth: "wide"
  }),
  day: T({
    values: Pd,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: xd,
    defaultWidth: "wide"
  })
};
const kd = _d;
var Ed = /^(\d+)(ième|ère|ème|er|e)?/i, Dd = /\d+/i, Td = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, $d = {
  any: [/^av/i, /^ap/i]
}, Sd = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Wd = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nd = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Od = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jd = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, zd = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, Ld = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, Hd = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, Rd = {
  ordinalNumber: ge({
    matchPattern: Ed,
    parsePattern: Dd,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: $({
    matchPatterns: Td,
    defaultMatchWidth: "wide",
    parsePatterns: $d,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: Sd,
    defaultMatchWidth: "wide",
    parsePatterns: Wd,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Nd,
    defaultMatchWidth: "wide",
    parsePatterns: Od,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: jd,
    defaultMatchWidth: "wide",
    parsePatterns: zd,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: Ld,
    defaultMatchWidth: "any",
    parsePatterns: Hd,
    defaultParseWidth: "any"
  })
};
const Ad = Rd;
var Fd = {
  code: "fr",
  formatDistance: ud,
  formatLong: vd,
  formatRelative: yd,
  localize: kd,
  match: Ad,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Id = Fd;
var Yd = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, qd = function(t, a, r) {
  var n, o = Yd[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", a.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + n : n + " fa" : n;
};
const Ud = qd;
var Bd = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Xd = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vd = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Jd = {
  date: W({
    formats: Bd,
    defaultWidth: "full"
  }),
  time: W({
    formats: Xd,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Vd,
    defaultWidth: "full"
  })
};
const Qd = Jd;
var Ut = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function Kd(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + Ut[e] + " scorso alle' p";
  }
}
function ha(e) {
  return "'" + Ut[e] + " alle' p";
}
function Zd(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + Ut[e] + " prossimo alle' p";
  }
}
var Gd = {
  lastWeek: function(t, a, r) {
    var n = t.getUTCDay();
    return ua(t, a, r) ? ha(n) : Kd(n);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(t, a, r) {
    var n = t.getUTCDay();
    return ua(t, a, r) ? ha(n) : Zd(n);
  },
  other: "P"
}, eu = function(t, a, r, n) {
  var o = Gd[t];
  return typeof o == "function" ? o(a, r, n) : o;
};
const tu = eu;
var au = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, ru = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, nu = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
}, ou = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
}, iu = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, su = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, lu = function(t, a) {
  var r = Number(t);
  return String(r);
}, du = {
  ordinalNumber: lu,
  era: T({
    values: au,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: ru,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: nu,
    defaultWidth: "wide"
  }),
  day: T({
    values: ou,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: iu,
    defaultWidth: "wide",
    formattingValues: su,
    defaultFormattingWidth: "wide"
  })
};
const uu = du;
var mu = /^(\d+)(º)?/i, cu = /\d+/i, fu = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, hu = {
  any: [/^a/i, /^(d|e)/i]
}, vu = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, gu = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, pu = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, yu = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, bu = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, Mu = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, wu = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, Pu = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, xu = {
  ordinalNumber: ge({
    matchPattern: mu,
    parsePattern: cu,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: fu,
    defaultMatchWidth: "wide",
    parsePatterns: hu,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: vu,
    defaultMatchWidth: "wide",
    parsePatterns: gu,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: pu,
    defaultMatchWidth: "wide",
    parsePatterns: yu,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: bu,
    defaultMatchWidth: "wide",
    parsePatterns: Mu,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: wu,
    defaultMatchWidth: "any",
    parsePatterns: Pu,
    defaultParseWidth: "any"
  })
};
const Cu = xu;
var _u = {
  code: "it",
  formatDistance: Ud,
  formatLong: Qd,
  formatRelative: tu,
  localize: uu,
  match: Cu,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Ke = _u;
var ku = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, Eu = function(t, a, r) {
  var n, o = ku[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + n : n + " geleden" : n;
};
const Du = Eu;
var Tu = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, $u = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Su = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Wu = {
  date: W({
    formats: Tu,
    defaultWidth: "full"
  }),
  time: W({
    formats: $u,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Su,
    defaultWidth: "full"
  })
};
const Nu = Wu;
var Ou = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, ju = function(t, a, r, n) {
  return Ou[t];
};
const zu = ju;
var Lu = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Hu = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Ru = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
}, Au = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
}, Fu = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Iu = function(t, a) {
  var r = Number(t);
  return r + "e";
}, Yu = {
  ordinalNumber: Iu,
  era: T({
    values: Lu,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: Hu,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: Ru,
    defaultWidth: "wide"
  }),
  day: T({
    values: Au,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: Fu,
    defaultWidth: "wide"
  })
};
const qu = Yu;
var Uu = /^(\d+)e?/i, Bu = /\d+/i, Xu = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, Vu = {
  any: [/^v/, /^n/]
}, Ju = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Qu = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ku = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Zu = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
}, Gu = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, em = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, tm = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, am = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, rm = {
  ordinalNumber: ge({
    matchPattern: Uu,
    parsePattern: Bu,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: Xu,
    defaultMatchWidth: "wide",
    parsePatterns: Vu,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: Ju,
    defaultMatchWidth: "wide",
    parsePatterns: Qu,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Ku,
    defaultMatchWidth: "wide",
    parsePatterns: Zu,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: Gu,
    defaultMatchWidth: "wide",
    parsePatterns: em,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: tm,
    defaultMatchWidth: "any",
    parsePatterns: am,
    defaultParseWidth: "any"
  })
};
const nm = rm;
var om = {
  code: "nl",
  formatDistance: Du,
  formatLong: Nu,
  formatRelative: zu,
  localize: qu,
  match: nm,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const im = om;
var sm = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, lm = function(t, a, r) {
  var n, o = sm[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "daqui a " + n : "há " + n : n;
};
const dm = lm;
var um = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, mm = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, cm = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fm = {
  date: W({
    formats: um,
    defaultWidth: "full"
  }),
  time: W({
    formats: mm,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: cm,
    defaultWidth: "full"
  })
};
const hm = fm;
var vm = {
  lastWeek: function(t) {
    var a = t.getUTCDay(), r = a === 0 || a === 6 ? "último" : "última";
    return "'" + r + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, gm = function(t, a, r, n) {
  var o = vm[t];
  return typeof o == "function" ? o(a) : o;
};
const pm = gm;
var ym = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, bm = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Mm = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, wm = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, Pm = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, xm = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, Cm = function(t, a) {
  var r = Number(t);
  return r + "º";
}, _m = {
  ordinalNumber: Cm,
  era: T({
    values: ym,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: bm,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: Mm,
    defaultWidth: "wide"
  }),
  day: T({
    values: wm,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: Pm,
    defaultWidth: "wide",
    formattingValues: xm,
    defaultFormattingWidth: "wide"
  })
};
const km = _m;
var Em = /^(\d+)(º|ª)?/i, Dm = /\d+/i, Tm = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, $m = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
}, Sm = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, Wm = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Nm = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, Om = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jm = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, zm = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, Lm = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, Hm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, Rm = {
  ordinalNumber: ge({
    matchPattern: Em,
    parsePattern: Dm,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: Tm,
    defaultMatchWidth: "wide",
    parsePatterns: $m,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: Sm,
    defaultMatchWidth: "wide",
    parsePatterns: Wm,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Nm,
    defaultMatchWidth: "wide",
    parsePatterns: Om,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: jm,
    defaultMatchWidth: "wide",
    parsePatterns: zm,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: Lm,
    defaultMatchWidth: "any",
    parsePatterns: Hm,
    defaultParseWidth: "any"
  })
};
const Am = Rm;
var Fm = {
  code: "pt",
  formatDistance: dm,
  formatLong: hm,
  formatRelative: pm,
  localize: km,
  match: Am,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Im = Fm;
var Ym = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, qm = function(t, a, r) {
  var n, o = Ym[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : n = o.other.replace("{{count}}", String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "em " + n : "há " + n : n;
};
const Um = qm;
var Bm = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, Xm = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vm = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Jm = {
  date: W({
    formats: Bm,
    defaultWidth: "full"
  }),
  time: W({
    formats: Xm,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Vm,
    defaultWidth: "full"
  })
};
const Qm = Jm;
var Km = {
  lastWeek: function(t) {
    var a = t.getUTCDay(), r = a === 0 || a === 6 ? "último" : "última";
    return "'" + r + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Zm = function(t, a, r, n) {
  var o = Km[t];
  return typeof o == "function" ? o(a) : o;
};
const Gm = Zm;
var ec = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, tc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, ac = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
}, rc = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"],
  wide: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
}, nc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, oc = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, ic = function(t, a) {
  var r = Number(t);
  return (a == null ? void 0 : a.unit) === "week" ? r + "ª" : r + "º";
}, sc = {
  ordinalNumber: ic,
  era: T({
    values: ec,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: tc,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: ac,
    defaultWidth: "wide"
  }),
  day: T({
    values: rc,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: nc,
    defaultWidth: "wide",
    formattingValues: oc,
    defaultFormattingWidth: "wide"
  })
};
const lc = sc;
var dc = /^(\d+)[ºªo]?/i, uc = /\d+/i, mc = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, cc = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, fc = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, hc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vc = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, gc = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
}, pc = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, yc = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, bc = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, Mc = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, wc = {
  ordinalNumber: ge({
    matchPattern: dc,
    parsePattern: uc,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: mc,
    defaultMatchWidth: "wide",
    parsePatterns: cc,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: fc,
    defaultMatchWidth: "wide",
    parsePatterns: hc,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: vc,
    defaultMatchWidth: "wide",
    parsePatterns: gc,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: pc,
    defaultMatchWidth: "wide",
    parsePatterns: yc,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: bc,
    defaultMatchWidth: "any",
    parsePatterns: Mc,
    defaultParseWidth: "any"
  })
};
const Pc = wc;
var xc = {
  code: "pt-BR",
  formatDistance: Um,
  formatLong: Qm,
  formatRelative: Gm,
  localize: lc,
  match: Pc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Cc = xc;
var _c = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, kc = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], Ec = function(t, a, r) {
  var n, o = _c[t];
  return typeof o == "string" ? n = o : a === 1 ? n = o.one : r && r.onlyNumeric ? n = o.other.replace("{{count}}", String(a)) : n = o.other.replace("{{count}}", a < 13 ? kc[a] : String(a)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "om " + n : n + " sedan" : n;
};
const Dc = Ec;
var Tc = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, $c = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Sc = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Wc = {
  date: W({
    formats: Tc,
    defaultWidth: "full"
  }),
  time: W({
    formats: $c,
    defaultWidth: "full"
  }),
  dateTime: W({
    formats: Sc,
    defaultWidth: "full"
  })
};
const Nc = Wc;
var Oc = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, jc = function(t, a, r, n) {
  return Oc[t];
};
const zc = jc;
var Lc = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, Hc = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, Rc = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, Ac = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, Fc = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, Ic = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, Yc = function(t, a) {
  var r = Number(t), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
      case 2:
        return r + ":a";
    }
  return r + ":e";
}, qc = {
  ordinalNumber: Yc,
  era: T({
    values: Lc,
    defaultWidth: "wide"
  }),
  quarter: T({
    values: Hc,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: T({
    values: Rc,
    defaultWidth: "wide"
  }),
  day: T({
    values: Ac,
    defaultWidth: "wide"
  }),
  dayPeriod: T({
    values: Fc,
    defaultWidth: "wide",
    formattingValues: Ic,
    defaultFormattingWidth: "wide"
  })
};
const Uc = qc;
var Bc = /^(\d+)(:a|:e)?/i, Xc = /\d+/i, Vc = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, Jc = {
  any: [/^f/i, /^[ev]/i]
}, Qc = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, Kc = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zc = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, Gc = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, ef = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, tf = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, af = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, rf = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, nf = {
  ordinalNumber: ge({
    matchPattern: Bc,
    parsePattern: Xc,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: $({
    matchPatterns: Vc,
    defaultMatchWidth: "wide",
    parsePatterns: Jc,
    defaultParseWidth: "any"
  }),
  quarter: $({
    matchPatterns: Qc,
    defaultMatchWidth: "wide",
    parsePatterns: Kc,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: $({
    matchPatterns: Zc,
    defaultMatchWidth: "wide",
    parsePatterns: Gc,
    defaultParseWidth: "any"
  }),
  day: $({
    matchPatterns: ef,
    defaultMatchWidth: "wide",
    parsePatterns: tf,
    defaultParseWidth: "any"
  }),
  dayPeriod: $({
    matchPatterns: af,
    defaultMatchWidth: "any",
    parsePatterns: rf,
    defaultParseWidth: "any"
  })
};
const of = nf;
var sf = {
  code: "sv",
  formatDistance: Dc,
  formatLong: Nc,
  formatRelative: zc,
  localize: Uc,
  match: of,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const lf = sf, Ze = {
  AU: {
    countryCode: "AU",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ca,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-AU",
    name: "AU"
  },
  BR: {
    countryCode: "BR",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "HH:mm a",
        timeDateFull: "d 'de' MMM yyyy, HH:mm",
        timeDateShort: "d 'de' MMM, HH:mm",
        timeDayDateShort: "EEE, d 'de' MMM, HH:mm"
      },
      locale: Cc,
      timezone: "America/Sao_Paulo",
      today: "Hoje"
    },
    locale: "pt-BR",
    name: "BR"
  },
  CA: {
    countryCode: "CA",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm a",
        timeDateFull: "MMMM d, yyyy, h:mm a",
        timeDateShort: "MMM d, h:mm a",
        timeDayDateShort: "EEE, MMM d, h:mm a"
      },
      locale: Zs,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-CA",
    name: "CA"
  },
  CO: {
    countryCode: "CO",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: fa,
      timezone: "America/Bogota",
      today: "Hoy"
    },
    locale: "es-CO",
    name: "CO"
  },
  CX: {
    countryCode: "CX",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: ca,
      timezone: "Australia/Sydney",
      today: "Today"
    },
    locale: "en-CX",
    name: "CX"
  },
  DE: {
    countryCode: "DE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE, d. MMM, HH:mm"
      },
      locale: zs,
      timezone: "Europe/Berlin",
      today: "Heute"
    },
    locale: "de-DE",
    name: "DE"
  },
  DK: {
    countryCode: "DK",
    dateProperties: {
      format: {
        dateFull: "EEEE 'den' d. MMMM",
        dateShort: "d. MMM",
        time: "HH:mm",
        timeDateFull: "d. MMM yyyy, HH:mm",
        timeDateShort: "d. MMM, HH:mm",
        timeDayDateShort: "EEE 'den' d. MMM, HH:mm"
      },
      locale: ts,
      timezone: "Europe/Copenhagen",
      today: "I dag"
    },
    locale: "da-DK",
    name: "DK"
  },
  ES: {
    countryCode: "ES",
    dateProperties: {
      format: {
        dateFull: "EEEE, d 'de' MMMM",
        dateShort: "d 'de' MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: fa,
      timezone: "Europe/Madrid",
      today: "Hoy"
    },
    locale: "es-ES",
    name: "ES"
  },
  FR: {
    countryCode: "FR",
    dateProperties: {
      format: {
        dateFull: "EEEE d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: Id,
      timezone: "Europe/Paris",
      today: "Aujourd'hui"
    },
    locale: "fr-FR",
    name: "FR"
  },
  GZ: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: Ke,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "GZ"
  },
  IN: {
    countryCode: "IN",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: ml,
      timezone: "Asia/Kolkata",
      today: "Today"
    },
    locale: "en-IN",
    name: "IN"
  },
  IT: {
    countryCode: "IT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: Ke,
      timezone: "Europe/Rome",
      today: "Oggi"
    },
    locale: "it-IT",
    name: "IT"
  },
  KE: {
    countryCode: "KE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: Ae,
      timezone: "Africa/Nairobi",
      today: "Today"
    },
    locale: "en-KE",
    name: "KE"
  },
  NG: {
    countryCode: "NG",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: Ae,
      timezone: "Africa/Lagos",
      today: "Today"
    },
    locale: "en-NG",
    name: "NG"
  },
  NL: {
    countryCode: "NL",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: im,
      timezone: "Europe/Amsterdam",
      today: "Vandaag"
    },
    locale: "nl-NL",
    name: "NL"
  },
  NZ: {
    countryCode: "NZ",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: yl,
      timezone: "Pacific/Auckland",
      today: "Today"
    },
    locale: "en-NZ",
    name: "NZ"
  },
  OC: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: Ae,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "OC"
  },
  PT: {
    countryCode: "PT",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: Im,
      timezone: "Europe/Lisbon",
      today: "Hoje"
    },
    locale: "pt-PT",
    name: "PT"
  },
  SE: {
    countryCode: "SE",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: lf,
      timezone: "Europe/Stockholm",
      today: "Idag"
    },
    locale: "sv-SE",
    name: "SE"
  },
  SM: {
    countryCode: "SM",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "HH:mm",
        timeDateFull: "d MMM yyyy, HH:mm",
        timeDateShort: "d MMM, HH:mm",
        timeDayDateShort: "EEE, d MMM, HH:mm"
      },
      locale: Ke,
      timezone: "Europe/San_Marino",
      today: "Oggi"
    },
    locale: "it-SM",
    name: "SM"
  },
  US: {
    countryCode: "US",
    dateProperties: {
      format: {
        dateFull: "EEEE, MMMM d",
        dateShort: "MMM d",
        time: "h:mm aa zzz",
        timeDateFull: "MMMM d, yyyy, h:mm aa zzz",
        timeDateShort: "MM/dd h:mm aa",
        timeDayDateShort: "EEE MMM d, h:mm aa zzz"
      },
      locale: da,
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "en-US",
    name: "US"
  },
  WS: {
    countryCode: "GB",
    dateProperties: {
      format: {
        dateFull: "EEEE, do MMMM",
        dateShort: "do MMM",
        time: "h:mm a",
        timeDateFull: "do MMM yyyy, h:mm a",
        timeDateShort: "do MMM, h:mm a",
        timeDayDateShort: "EEE, do MMM, h:mm a"
      },
      locale: Ae,
      timezone: "Europe/London",
      today: "Today"
    },
    locale: "en-GB",
    name: "WS"
  },
  XX: {
    countryCode: "XX",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: da,
      // Placeholder locale
      timezone: "America/New_York",
      today: "Today"
    },
    locale: "xx-XX",
    name: "XX"
  },
  ZA: {
    countryCode: "ZA",
    dateProperties: {
      format: {
        dateFull: "EEEE, d MMMM",
        dateShort: "d MMM",
        time: "h:mm a",
        timeDateFull: "d MMM yyyy, h:mm a",
        timeDateShort: "d MMM, h:mm a",
        timeDayDateShort: "EEE, d MMM, h:mm a"
      },
      locale: _l,
      timezone: "Africa/Johannesburg",
      today: "Today"
    },
    locale: "en-ZA",
    name: "ZA"
  }
}, Ua = (e, t) => e ? zo(
  e,
  Ze[t].dateProperties.timezone,
  Ze[t].dateProperties.format.timeDateFull,
  {
    locale: Ze[t].dateProperties.locale
  }
) : "", Ba = (e, t, a) => {
  a && a.startsWith("http") && (a = a.replace(/^http:/, "https:"));
  const r = a || "https://www.oddschecker.com", n = t.toLowerCase(), o = e.startsWith("/") ? e.slice(1) : e;
  return `${r}/${n}/${o}`;
}, df = "_imageContainer_p8mnt_1", uf = "_overlay_p8mnt_18", mf = "_focusTopLeft_p8mnt_36", cf = "_focusTopCenter_p8mnt_40", ff = "_focusTopRight_p8mnt_44", hf = "_focusCenterLeft_p8mnt_48", vf = "_focusCenter_p8mnt_48", gf = "_focusCenterRight_p8mnt_56", pf = "_focusBottomLeft_p8mnt_60", yf = "_focusBottomCenter_p8mnt_64", bf = "_focusBottomRight_p8mnt_68", Mf = "_noOverlay_p8mnt_72", se = {
  imageContainer: df,
  overlay: uf,
  focusTopLeft: mf,
  focusTopCenter: cf,
  focusTopRight: ff,
  focusCenterLeft: hf,
  focusCenter: vf,
  focusCenterRight: gf,
  focusBottomLeft: pf,
  focusBottomCenter: yf,
  focusBottomRight: bf,
  noOverlay: Mf
}, Xa = ({
  alt: e,
  focusArea: t = "CENTER",
  imageContainerClass: a = se.imageContainer,
  imageOverlayClass: r = se.overlay,
  showOverlay: n = !1,
  url: o
}) => /* @__PURE__ */ X("div", { "aria-label": e, className: `${a} ${((i) => ({
  BOTTOM_CENTER: se.focusBottomCenter,
  BOTTOM_LEFT: se.focusBottomLeft,
  BOTTOM_RIGHT: se.focusBottomRight,
  CENTER: se.focusCenter,
  CENTER_LEFT: se.focusCenterLeft,
  CENTER_RIGHT: se.focusCenterRight,
  TOP_CENTER: se.focusTopCenter,
  TOP_LEFT: se.focusTopLeft,
  TOP_RIGHT: se.focusTopRight
})[i] || se.focusCenter)(t)}`, "data-testid": "article-image", children: [
  /* @__PURE__ */ w("img", { alt: e || "background image", src: o }),
  /* @__PURE__ */ w("div", { className: `${r} ${n ? "" : se.noOverlay}` })
] }), wf = "_lockBanner_pz94h_1", Pf = {
  lockBanner: wf
};
function xf(e) {
  return /* @__PURE__ */ w(
    "svg",
    {
      fill: "none",
      height: "100%",
      preserveAspectRatio: "xMidYMid",
      viewBox: "0 0 18 21",
      width: "18",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ w(
        "path",
        {
          d: "M9 12V14.25M0.75 8.25V19.5H17.25V8.25H0.75ZM3.75 8.25C3.75 3.75 3.75 0.75 9 0.75C14.25 0.75 14.25 3.75 14.25 8.25H3.75Z",
          stroke: "#00182E",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2"
        }
      )
    }
  );
}
const Cf = ({ isLoggedIn: e }) => /* @__PURE__ */ w("div", { className: Pf.lockBanner, children: e ? /* @__PURE__ */ w("span", { "data-testid": "unlocked-header", children: "unlocked" }) : /* @__PURE__ */ X("span", { "data-testid": "locked-header", children: [
  /* @__PURE__ */ w(xf, {}),
  "log in to view for free"
] }) });
function _f(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(a) {
    return t[a] === void 0 && (t[a] = e(a)), t[a];
  };
}
var kf = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Ge = /* @__PURE__ */ _f(
  function(e) {
    return kf.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ef = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), a = {}, r = [];
  t.forEach((o) => {
    (o ? o.split(" ") : []).forEach((i) => {
      if (i.startsWith("atm_")) {
        const [, l] = i.split("_");
        a[l] = i;
      } else
        r.push(i);
    });
  });
  const n = [];
  for (const o in a)
    Object.prototype.hasOwnProperty.call(a, o) && n.push(a[o]);
  return n.push(...r), n.join(" ");
}, va = Ef, Df = (e) => e.toUpperCase() === e, Tf = (e) => (t) => e.indexOf(t) === -1, Va = (e, t) => {
  const a = {};
  return Object.keys(e).filter(Tf(t)).forEach((r) => {
    a[r] = e[r];
  }), a;
};
function $f(e, t, a) {
  const r = Va(t, a);
  if (!e) {
    const n = typeof Ge == "function" ? { default: Ge } : Ge;
    Object.keys(r).forEach((o) => {
      n.default(o) || delete r[o];
    });
  }
  return r;
}
var Sf = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const a = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${a}' in the component '${t}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, Wf = 0;
function ga(e) {
  let t = "";
  return process.env.NODE_ENV === "test" && (t += `mocked-styled-${Wf++}`, e && e.__wyw_meta && e.__wyw_meta.className && (t += ` ${e.__wyw_meta.className}`)), (a) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(a))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const r = (o, s) => {
      const { as: i = e, class: l = t } = o, d = a.propsAsIs === void 0 ? !(typeof i == "string" && i.indexOf("-") === -1 && !Df(i[0])) : a.propsAsIs, u = $f(d, o, [
        "as",
        "class"
      ]);
      u.ref = s, u.className = a.atomic ? va(a.class, u.className || l) : va(u.className || l, a.class);
      const { vars: g } = a;
      if (g) {
        const M = {};
        for (const k in g) {
          const p = g[k], f = p[0], h = p[1] || "", m = typeof f == "function" ? f(o) : f;
          Sf(m, a.name), M[`--${k}`] = `${m}${h}`;
        }
        const b = u.style || {}, P = Object.keys(b);
        P.length > 0 && P.forEach((k) => {
          M[k] = b[k];
        }), u.style = M;
      }
      return e.__wyw_meta && e !== i ? (u.as = i, be(e, u)) : be(i, u);
    }, n = Xt ? Xt(r) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (o) => {
        const s = Va(o, ["innerRef"]);
        return r(s, o.innerRef);
      }
    );
    return n.displayName = a.name, n.__wyw_meta = {
      className: a.class || t,
      extends: e
    }, n;
  };
}
var oe = process.env.NODE_ENV !== "production" ? new Proxy(ga, {
  get(e, t) {
    return e(t);
  }
}) : ga;
const Nf = /* @__PURE__ */ oe("a")({
  name: "Item",
  class: "Item_iszlaff",
  propsAsIs: !1
}), Of = /* @__PURE__ */ oe("div")({
  name: "TitleContainer",
  class: "TitleContainer_t153vcsb",
  propsAsIs: !1
}), jf = "imageContainer_i1ul0mop", zf = /* @__PURE__ */ oe("div")({
  name: "Title",
  class: "Title_t3rcaza",
  propsAsIs: !1
}), Bt = /* @__PURE__ */ oe("div")({
  name: "Author",
  class: "Author_a12y2f5c",
  propsAsIs: !1
}), Lf = /* @__PURE__ */ oe("div")({
  name: "FlexWrapper",
  class: "FlexWrapper_f1svo7vk",
  propsAsIs: !1
}), Hf = () => Bt, Rf = /* @__PURE__ */ oe(Hf())({
  name: "PublishedDate",
  class: "PublishedDate_p10yfybh",
  propsAsIs: !0
}), Af = () => Bt, Ff = /* @__PURE__ */ oe(Af())({
  name: "ReadTime",
  class: "ReadTime_reepqgx",
  propsAsIs: !0
}), If = /* @__PURE__ */ oe("p")({
  name: "Description",
  class: "Description_dckalez",
  propsAsIs: !1
}), Yf = ({
  aiGeneratedId: e,
  authors: t = [],
  baseUrl: a,
  componentTags: r = [],
  description: n,
  image: o,
  isLoggedIn: s,
  publishedTime: i,
  readTime: l,
  repub: d,
  requestUrl: u,
  title: g,
  url: M
}) => {
  const b = () => {
    Ea({
      aiArticle: e ? "yes" : "no",
      articleName: g,
      event: Da.ARTICLE_CLICK,
      tipsterName: t[0].fullName
    });
  }, P = Ua(i, d), k = r.includes("TIPS_PREMIUM"), p = Ba(M, d, a);
  return /* @__PURE__ */ X("div", { children: [
    k && /* @__PURE__ */ w(Cf, { isLoggedIn: s }),
    /* @__PURE__ */ X(Nf, { "data-testid": "article-item", href: je(p, u), onClick: b, children: [
      o && /* @__PURE__ */ w(
        Xa,
        {
          alt: o.alt,
          focusArea: o.focusArea,
          imageContainerClass: jf,
          url: Ta(o.url, 350)
        }
      ),
      /* @__PURE__ */ X(Of, { children: [
        /* @__PURE__ */ w(zf, { "data-testid": "article-title", children: g }),
        n && /* @__PURE__ */ w(If, { "data-testid": "article-description", children: n }),
        /* @__PURE__ */ X(Lf, { children: [
          /* @__PURE__ */ X("div", { children: [
            t.length && /* @__PURE__ */ w(Bt, { "data-testid": "article-author", children: t[0].fullName }),
            i && /* @__PURE__ */ w(Rf, { "data-testid": "article-published-time", children: P })
          ] }),
          /* @__PURE__ */ w("div", { children: l && /* @__PURE__ */ w(Ff, { "data-testid": "article-read-time", children: l }) })
        ] })
      ] })
    ] })
  ] });
}, qf = "_wrapper_1h6cv_3", Uf = "_heroArticle_1h6cv_9", Bf = "_imageContainer_1h6cv_21", Xf = "_contentContainer_1h6cv_37", Vf = "_overlay_1h6cv_48", Jf = "_title_1h6cv_59", Qf = "_metadata_1h6cv_68", Kf = "_metadataLeft_1h6cv_75", Zf = "_metadataRight_1h6cv_81", Gf = "_mobileTimestamp_1h6cv_87", eh = "_desktopTimestamp_1h6cv_96", th = "_readTime_1h6cv_100", ah = "_mobileAuthor_1h6cv_110", rh = "_desktopAuthor_1h6cv_119", ie = {
  wrapper: qf,
  heroArticle: Uf,
  imageContainer: Bf,
  contentContainer: Xf,
  overlay: Vf,
  title: Jf,
  metadata: Qf,
  metadataLeft: Kf,
  metadataRight: Zf,
  mobileTimestamp: Gf,
  desktopTimestamp: eh,
  readTime: th,
  mobileAuthor: ah,
  desktopAuthor: rh
}, nh = ({
  authors: e = [],
  baseUrl: t,
  deviceType: a,
  image: r,
  publishedTime: n,
  readTime: o,
  repub: s,
  requestUrl: i,
  title: l,
  url: d
}) => {
  var p, f, h, m;
  const u = () => {
    Ea({
      articleName: l,
      event: Da.HERO_ARTICLE_VIEW,
      tipsterName: e[0].fullName
    });
  }, g = Ua(n, s), M = ((p = e[0]) == null ? void 0 : p.shortName) || ((f = e[0]) == null ? void 0 : f.fullName) || "", b = ((h = e[0]) == null ? void 0 : h.fullName) || ((m = e[0]) == null ? void 0 : m.shortName) || "", P = a === "MOBILE" ? 500 : a === "TABLET" ? 800 : 1e3, k = Ba(d, s, t);
  return /* @__PURE__ */ w(
    "a",
    {
      className: ie.wrapper,
      "data-testid": "hero-article",
      href: je(k, i),
      onClick: u,
      children: /* @__PURE__ */ X("div", { className: ie.heroArticle, children: [
        /* @__PURE__ */ w(
          Xa,
          {
            alt: r.alt,
            focusArea: r.focusArea,
            imageContainerClass: ie.imageContainer,
            imageOverlayClass: ie.overlay,
            showOverlay: !0,
            url: Ta(r.url, P)
          }
        ),
        /* @__PURE__ */ X("div", { className: ie.contentContainer, children: [
          /* @__PURE__ */ w("h2", { className: ie.title, "data-testid": "hero-article-title", children: l }),
          /* @__PURE__ */ X("div", { className: ie.metadata, children: [
            /* @__PURE__ */ X("div", { className: ie.metadataLeft, children: [
              /* @__PURE__ */ w("div", { className: ie.mobileAuthor, "data-testid": "hero-article-author-short-name", children: M }),
              /* @__PURE__ */ w("div", { className: ie.desktopAuthor, "data-testid": "hero-article-author-full-name", children: b }),
              /* @__PURE__ */ w("div", { className: ie.mobileTimestamp, "data-testid": "hero-article-publish-time", children: g })
            ] }),
            /* @__PURE__ */ X("div", { className: ie.metadataRight, children: [
              /* @__PURE__ */ w("span", { className: ie.desktopTimestamp, "data-testid": "hero-article-publish-time-read-time", children: `${g} | ${o}` }),
              /* @__PURE__ */ w("span", { className: ie.readTime, "data-testid": "hero-article-read-time", children: o })
            ] })
          ] })
        ] })
      ] })
    }
  );
};
function Ja(e) {
  var t, a, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var n = e.length;
      for (t = 0; t < n; t++)
        e[t] && (a = Ja(e[t])) && (r && (r += " "), r += a);
    } else
      for (a in e)
        e[a] && (r && (r += " "), r += a);
  return r;
}
function oh() {
  for (var e, t, a = 0, r = "", n = arguments.length; a < n; a++)
    (e = arguments[a]) && (t = Ja(e)) && (r && (r += " "), r += t);
  return r;
}
const ih = "_up_77ag3_1", sh = "_down_77ag3_6", lh = "_right_77ag3_11", dh = "_left_77ag3_16", uh = "_md_77ag3_21", mh = "_sm_77ag3_26", ch = "_loading_77ag3_31", fh = "_light_77ag3_39", hh = "_dark_77ag3_42", pa = {
  up: ih,
  down: sh,
  right: lh,
  left: dh,
  md: uh,
  sm: mh,
  loading: ch,
  light: fh,
  dark: hh
}, vh = ({ variant: e }) => /* @__PURE__ */ w("span", { className: oh(pa.loading, pa[e]), children: "" });
const gh = "pageLink_phpa8aq", ph = "paginationBreak_pcujydz", yh = "paginationBreakLink_pycfaqa", bh = "activePageLink_afjaptn", Mh = /* @__PURE__ */ oe("div")({
  name: "Container",
  class: "Container_c7rub8e",
  propsAsIs: !1
}), wh = /* @__PURE__ */ oe("div")({
  name: "Header",
  class: "Header_hry9e47",
  propsAsIs: !1
}), Ph = () => ({
  isHref: e
}) => e ? "underline" : "none", xh = /* @__PURE__ */ oe("a")({
  name: "HeadingLink",
  class: "HeadingLink_h1y3vfz9",
  propsAsIs: !1,
  vars: {
    "h1y3vfz9-0": [Ph()]
  }
}), Ch = () => ({
  isCentered: e
}) => e ? "center" : "flex-start", _h = /* @__PURE__ */ oe("div")({
  name: "Footer",
  class: "Footer_f1k2k5nt",
  propsAsIs: !1,
  vars: {
    "f1k2k5nt-0": [Ch()]
  }
}), kh = () => ({
  rows: e
}) => `repeat(${e}, auto)`, Eh = /* @__PURE__ */ oe("div")({
  name: "ItemsContainer",
  class: "ItemsContainer_i1qes62j",
  propsAsIs: !1,
  vars: {
    "i1qes62j-0": [kh()]
  }
}), Dh = /* @__PURE__ */ oe("a")({
  name: "ArrowLink",
  class: "ArrowLink_aflq8vc",
  propsAsIs: !1
}), Th = /* @__PURE__ */ oe("button")({
  name: "LoadMoreButtonLink",
  class: "LoadMoreButtonLink_l102uha3",
  propsAsIs: !1
}), $h = {
  FIRST_ARTICLE: "FIRST_ARTICLE",
  NONE: "NONE"
}, Sh = ({
  articles: e,
  articlesPage: t,
  baseUrl: a,
  defaultFeaturedArticle: r,
  deviceType: n,
  featuredArticleId: o,
  hasNextPage: s,
  isLoading: i,
  isLoggedIn: l,
  limit: d,
  loadMoreArticles: u,
  moreArticlesPath: g,
  moreArticlesText: M = "More Picks",
  pagination: b,
  paginationNextLabel: P,
  paginationPrevLabel: k,
  repub: p,
  requestUrl: f,
  title: h,
  total: m,
  type: c
}) => {
  const v = "oddschecker", x = Math.ceil(m / (d ?? 10)), S = (C) => {
    const O = C.selected + 1, j = new URL(window.location.href);
    O === 1 ? j.searchParams.delete("articlesPage") : j.searchParams.set("articlesPage", O.toString()), window.location.href = je(j.toString());
  }, R = e.find((C) => C.id === o) || (r === $h.FIRST_ARTICLE ? e[0] : null), de = R ? e.filter((C) => C.id !== R.id) : e, Ce = () => g ? /* @__PURE__ */ X(Dh, { "data-testid": "more-articles-link", href: je(g, f), children: [
    M,
    /* @__PURE__ */ w("svg", { fill: "none", height: "10", viewBox: "0 0 11 10", width: "11", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ w(
      "path",
      {
        d: "M4.00003 0.757359L8.24267 5L4.00003 9.24264",
        stroke: "var(--cxy-color-interactive-secondary-subtle)",
        strokeWidth: "1.5"
      }
    ) })
  ] }) : null, E = () => s ? /* @__PURE__ */ w(Th, { "data-testid": "more-articles-link", disabled: i, onClick: u, children: i ? /* @__PURE__ */ w(vh, { variant: "light" }) : M }) : null;
  return /* @__PURE__ */ X(Mh, { "data-fpsm-theme": v, "data-testid": "more-articles", children: [
    R && /* @__PURE__ */ w(nh, { ...R, baseUrl: a, deviceType: n, repub: p, requestUrl: f }),
    h && /* @__PURE__ */ w(wh, { children: /* @__PURE__ */ w(
      xh,
      {
        "data-testid": "more-articles-title",
        href: g ? je(g, f) : void 0,
        isHref: !!g,
        title: h,
        children: h
      }
    ) }),
    /* @__PURE__ */ w(Eh, { rows: e.length, children: de.map((C) => /* @__PURE__ */ be(
      Yf,
      {
        ...C,
        articleType: c,
        baseUrl: a,
        isLoggedIn: l,
        key: C.id,
        repub: p,
        requestUrl: f
      }
    )) }),
    b !== "NO_PAGINATION" && /* @__PURE__ */ X(_h, { isCentered: !g, children: [
      b === "BOTTOM_PAGE_NUMBERS" && x > 1 && /* @__PURE__ */ w(
        Cn,
        {
          activeLinkClassName: bh,
          breakClassName: ph,
          breakLabel: "...",
          breakLinkClassName: yh,
          forcePage: t - 1,
          hrefAllControls: !0,
          hrefBuilder: (C, O, j) => {
            if (C < 1 || C === j + 1)
              return;
            if (C === 1) {
              if (typeof window < "u") {
                const _ = new URL(window.location.href);
                _.searchParams.delete("articlesPage");
                const y = _.searchParams.toString();
                return y ? `${_.pathname}?${y}` : _.pathname;
              }
              const V = new URL(f);
              V.searchParams.delete("articlesPage");
              const J = V.searchParams.toString();
              return J ? `${V.pathname}?${J}` : V.pathname;
            }
            if (typeof window < "u") {
              const V = new URL(window.location.href);
              return V.searchParams.set("articlesPage", String(C)), `${V.pathname}?${V.searchParams.toString()}`;
            }
            const ee = new URL(f);
            return ee.searchParams.set("articlesPage", String(C)), `${ee.pathname}?${ee.searchParams.toString()}`;
          },
          marginPagesDisplayed: 1,
          nextLabel: P,
          onPageChange: S,
          pageCount: x,
          pageLinkClassName: gh,
          pageRangeDisplayed: 1,
          previousLabel: k,
          selectedPageRel: null
        }
      ),
      b === "MORE_ARTICLES_LINKS" && g && /* @__PURE__ */ w(Ce, {}),
      b === "LOAD_MORE_BUTTON" && /* @__PURE__ */ w(E, {})
    ] })
  ] });
}, Wh = ({
  articlesPage: e,
  dataApiEndpoint: t,
  defaultFeaturedArticle: a,
  deviceType: r,
  featuredArticleId: n,
  isLoggedIn: o,
  moreArticlesPath: s,
  moreArticlesText: i,
  title: l,
  ...d
}) => {
  const [u, g] = Pa(100), M = Number.isFinite(e) && e > 0 ? e : 1, b = Sa(d), { data: P, fetchNextPage: k, hasNextPage: p, isFetchingNextPage: f } = sr({
    getNextPageParam(c, v) {
      if (!(!c || c.length < d.limit))
        return v.length;
    },
    initialPageParam: M - 1,
    queryFn: async ({ pageParam: c }) => {
      const v = await $a(
        t,
        {
          ...d,
          offset: c * d.limit
        },
        {
          logger: console
        }
      );
      return v ? (g(v.total), v.articles) : [];
    },
    queryKey: b,
    refetchOnMount: d.pagination === "BOTTOM_PAGE_NUMBERS" ? "always" : !1
    // this is to ensure that we get the articles total
  });
  if (!P || P.pages.flat().length === 0)
    return null;
  const m = P.pages.flat().filter((c) => c !== null);
  return /* @__PURE__ */ w(
    Sh,
    {
      articles: m,
      articlesPage: M,
      baseUrl: d.baseUrl,
      defaultFeaturedArticle: a,
      deviceType: r,
      featuredArticleId: n,
      hasNextPage: p,
      isLoading: f,
      isLoggedIn: o,
      limit: d.limit,
      loadMoreArticles: k,
      moreArticlesPath: s,
      moreArticlesText: i,
      offset: d.offset,
      pagination: d.pagination,
      repub: d.repub,
      requestUrl: d.requestUrl,
      title: l,
      total: u,
      type: d.type
    }
  );
};
var Nh = /* @__PURE__ */ ((e) => (e.Insights = "INSIGHTS", e.Tips = "TIPS", e))(Nh || {}), Oh = typeof xe == "object" && xe && xe.Object === Object && xe, jh = typeof self == "object" && self && self.Object === Object && self, zh = Oh || jh || Function("return this")(), ya = zh.Symbol, ba = ya ? ya.prototype : void 0;
ba && ba.toString;
var Lh = typeof xe == "object" && xe && xe.Object === Object && xe, Hh = typeof self == "object" && self && self.Object === Object && self, Rh = Lh || Hh || Function("return this")(), Ma = Rh.Symbol, wa = Ma ? Ma.prototype : void 0;
wa && wa.toString;
(function(e) {
  typeof globalThis != "object" && (this ? t() : (e.defineProperty(e.prototype, "_T_", {
    configurable: !0,
    get: t
  }), _T_));
  function t() {
    var a = this || self;
    a.globalThis = a, delete e.prototype._T_;
  }
})(Object);
const Ah = (e, t) => t.skipDedupe || t.method !== "GET", Fh = (e, t) => t.method + "@" + e, Ih = (e) => e.clone(), Qa = ({ skip: e = Ah, key: t = Fh, resolver: a = Ih } = {}) => {
  const r = /* @__PURE__ */ new Map();
  return (n) => (o, s) => {
    if (e(o, s))
      return n(o, s);
    const i = t(o, s);
    if (!r.has(i))
      r.set(i, []);
    else
      return new Promise((l, d) => {
        r.get(i).push([l, d]);
      });
    try {
      return n(o, s).then((l) => (r.get(i).forEach(([d]) => d(a(l))), r.delete(i), l)).catch((l) => {
        throw r.get(i).forEach(([, d]) => d(l)), r.delete(i), l;
      });
    } catch (l) {
      return r.delete(i), Promise.reject(l);
    }
  };
}, Yh = (e, t) => t.skipCache || t.method !== "GET", qh = (e, t) => t.method + "@" + e, Uh = () => !1, Bh = () => null, Xh = (e) => e.ok, Vh = ({ throttle: e = 1e3, skip: t = Yh, key: a = qh, clear: r = Uh, invalidate: n = Bh, condition: o = Xh, flagResponseOnCacheHit: s = "__cached" } = {}) => {
  const i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Set(), u = (M) => {
    e && !d.has(M) && (d.add(M), setTimeout(() => {
      d.delete(M);
    }, e));
  }, g = (M) => (b, P) => {
    const k = a(b, P);
    let p = n(b, P);
    if (p && (p instanceof Array || (p = [p]), p.forEach((f) => {
      typeof f == "string" ? i.delete(f) : f instanceof RegExp && i.forEach((h, m) => {
        f.test(m) && i.delete(m);
      });
    })), r(b, P) && i.clear(), t(b, P))
      return M(b, P);
    if (d.has(k)) {
      if (i.has(k)) {
        const f = i.get(k).clone();
        return s && Object.defineProperty(f, s, {
          value: k,
          enumerable: !1
        }), Promise.resolve(f);
      } else if (l.has(k))
        return new Promise((f, h) => {
          l.get(k).push([f, h]);
        });
    }
    return l.has(k) || l.set(k, []), u(k), M(b, P).then((f) => (o(f.clone()) && i.set(k, f.clone()), l.get(k).forEach(([h]) => h(f.clone())), l.delete(k), f)).catch((f) => {
      throw l.get(k).forEach(([, h]) => h(f)), l.delete(k), f;
    });
  };
  return g.cacheResponse = function(M, b) {
    u(M), i.set(M, b);
  }, g.cache = i, g.inflight = l, g.throttling = d, g;
}, Jh = (e, t) => e * t, Qh = (e) => e && e.ok, Ka = ({ delayTimer: e = 500, delayRamp: t = Jh, maxAttempts: a = 10, until: r = Qh, onRetry: n = null, retryOnNetworkError: o = !1, resolveWithLatestResponse: s = !1, skip: i } = {}) => (l) => (d, u) => {
  let g = 0;
  if (i && i(d, u))
    return l(d, u);
  const M = (b, P) => Promise.resolve(r(b, P)).then((k) => k ? b && s ? b : P ? Promise.reject(P) : b : (g++, !a || g <= a ? new Promise((p) => {
    const f = t(e, g);
    setTimeout(() => {
      typeof n == "function" ? Promise.resolve(n({
        response: b,
        error: P,
        url: d,
        options: u
      })).then((h = {}) => {
        var m, c;
        p(l((m = h && h.url) !== null && m !== void 0 ? m : d, (c = h && h.options) !== null && c !== void 0 ? c : u));
      }) : p(l(d, u));
    }, f);
  }).then(M).catch((p) => {
    if (!o)
      throw p;
    return M(null, p);
  }) : b && s ? b : Promise.reject(P || new Error("Number of attempts exceeded."))));
  return l(d, u).then(M).catch((b) => {
    if (!o)
      throw b;
    return M(null, b);
  });
};
Me().middlewares([
  Qa(),
  Ka({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  Vh({
    key: (e, t) => t.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 7
    // 7 days (max safe is ~24.8 days)
  })
]);
Me().middlewares([
  Qa(),
  Ka({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]);
function Kh(e = {}) {
  return new ir.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(t) {
          return t * 100;
        }
      }
    },
    ...e
  });
}
const iv = async (e, t) => {
  const a = Kh(), r = Number.isFinite(e.articlesPage) && e.articlesPage > 0 ? e.articlesPage : 1, n = Math.max(0, (r - 1) * e.limit);
  let o = 0;
  try {
    const d = {
      countryCode: e.countryCode,
      limit: e.limit,
      offset: n,
      pagination: e.pagination,
      repub: e.repub,
      requestUrl: e.requestUrl,
      subdivision: e.subdivision,
      topics: e.topics,
      type: e.type
    };
    await a.prefetchInfiniteQuery({
      getNextPageParam(u, g) {
        if (!(!u || u.length < e.limit))
          return g.length;
      },
      initialPageParam: r - 1,
      queryFn: async ({ pageParam: u = 0 }) => {
        const g = await $a(
          t,
          {
            ...d,
            offset: u * e.limit
          },
          { nocache: e.nocache }
        );
        return g && (o = g.total), g.articles;
      },
      queryKey: Sa(d),
      staleTime: 1 / 0
    });
  } catch {
  }
  const s = lr(a), i = Math.ceil(o / e.limit), l = {
    articlesPerPage: e.limit,
    currentPage: r,
    hasNextPage: r < i,
    hasPrevPage: r > 1,
    totalArticles: o,
    totalPages: i
  };
  return {
    dehydratedState: s,
    paginationMeta: l
  };
}, Zh = (e) => new cr({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      retry: (t, a) => {
        var r;
        return ((r = a == null ? void 0 : a.response) == null ? void 0 : r.status) === 404 ? !1 : t < 2;
      },
      retryDelay: (t) => Math.min(1e3 * (t + 1), 3e3),
      staleTime: e ? 0 : 1 / 0
    }
  }
}), Gh = ({ resetErrorBoundary: e }) => (or(() => {
  e();
}, [e]), null);
function sv({ dehydratedState: e, nocache: t, ...a }) {
  const [r] = Pa(() => {
    const n = Zh(t);
    return dr(n, e), n;
  });
  return /* @__PURE__ */ w(Cr, { children: /* @__PURE__ */ w(ur, { client: r, children: /* @__PURE__ */ w(mr, { children: ({ reset: n }) => /* @__PURE__ */ w(
    gr,
    {
      fallbackRender: ({ resetErrorBoundary: o }) => /* @__PURE__ */ w(Gh, { resetErrorBoundary: o }),
      onReset: n,
      children: /* @__PURE__ */ w(_r, { i18nInstance: a.i18n, children: /* @__PURE__ */ w(nr, { fallback: /* @__PURE__ */ w(Er, {}), children: /* @__PURE__ */ w(Wh, { ...a }) }) })
    }
  ) }) }) });
}
export {
  Nh as ArticleTypes,
  sv as MoreArticlesWithQuery,
  iv as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
